/* eslint-disable max-len */
import { ErrorFeature } from "./inverter.model";

/* eslint-disable no-bitwise */
export type ErrorCatalog = {
  [key: number]: {
    [key: number]: ErrorFeature;
  };
};

export const faultsG2: ErrorCatalog = {
  1: {
    [1 << 0]: {
      description: 'Grid voltage is too high (GridOVP)',
      source: 'Grid',
      classification: 'Grid',
      id: 1,
    },
    [1 << 1]: {
      description: 'Grid voltage is too low (GridUVP)',
      source: 'Grid',
      classification: 'Grid',
      id: 2,
    },
    [1 << 2]: {
      description: 'Grid frequency is too high (GridOFP)',
      source: 'Grid',
      classification: 'Grid',
      id: 3,
    },
    [1 << 3]: {
      description: 'Grid frequency is too low (GridUFP)',
      source: 'Grid',
      classification: 'Grid',
      id: 4,
    },
    [1 << 4]: {
      description: 'Battery voltage is too high (BatOVP)',
      source: 'Battery',
      classification: 'Battery',
      id: 5,
    },
    // Bit5 is reserved
    [1 << 6]: {
      description: 'LVRT function is faulty (LVRT fault)',
      source: 'Grid',
      classification: 'Grid',
      id: 7,
    },
    [1 << 7]: {
      description: 'Input voltage is too high (PVOVP)',
      source: 'PV',
      classification: 'PV',
      id: 8,
    },
    [1 << 8]: {
      description: 'Voltage on LLCBus is too high (HW_LLCBus_OVP)',
      source: 'Hardware',
      classification: 'Hardware',
      id: 9,
    },
    [1 << 9]: {
      description: 'Voltage on booster section is too high (HW_Boost_OVP)',
      source: 'Booster',
      classification: 'Voltage',
      id: 10,
    },
    [1 << 10]: {
      description: 'Current on Buck Boost section is too high (HWBuckBoostOCP)',
      source: 'Buck Boost',
      classification: 'Current',
      id: 11,
    },
    [1 << 11]: {
      description: 'Battery current is too high (HwBatOCP)',
      source: 'Battery',
      classification: 'Battery',
      id: 12,
    },
    [1 << 12]: {
      description: 'Ground Fault current is too high (GFCI OCP)',
      source: 'Ground',
      classification: 'Current',
      id: 13,
    },
    [1 << 13]: {
      description: 'Input current is too high (HWPVOCP)',
      source: 'Input',
      classification: 'Current',
      id: 14,
    },
    [1 << 14]: {
      description: 'Grid current is too high (HwAcOCP)',
      source: 'Grid',
      classification: 'Current',
      id: 15,
    },
    [1 << 15]: {
      description: 'Input current is unbalanced (IpvUnbalance)',
      source: 'Input',
      classification: 'Current',
      id: 16,
    },
  },
  2: {
    [1 << 0]: {
      description: 'Grid current sampling error (HwADFaultIGrid)',
      source: 'Grid',
      classification: 'Sampling',
      id: 17,
    },
    [1 << 1]: {
      description: 'DCI sampling error (HwADFaultDCI)',
      source: 'DCI',
      classification: 'Sampling',
      id: 18,
    },
    [1 << 2]: {
      description: 'Grid voltage sampling error (HwADFaultVGrid)',
      source: 'Grid',
      classification: 'Sampling',
      id: 19,
    },
    [1 << 3]: {
      description: 'GFCI sampling error (GFCIDeviceFault)',
      source: 'GFCI',
      classification: 'Sampling',
      id: 20,
    },
    [1 << 4]: {
      description: 'Master chip fault (MChip_Fault)',
      source: 'Chip',
      classification: 'Hardware',
      id: 21,
    },
    [1 << 5]: {
      description: 'Auxiliary voltage error (HwAuxPowerFault)',
      source: 'Auxiliary',
      classification: 'Voltage',
      id: 22,
    },
    // Bits 6 and 7 are reserved
    [1 << 8]: {
      description: 'Voltage on LLCBus is too high (LLCBusOVP)',
      source: 'LLCBus',
      classification: 'Voltage',
      id: 25,
    },
    [1 << 9]: {
      description: 'Voltage on LLCBus is too high (SwBusOVP)', // Seems repeated in the data
      source: 'LLCBus',
      classification: 'Voltage',
      id: 26,
    },
    [1 << 10]: {
      description: 'Battery current is too high (BatOCP)',
      source: 'Battery',
      classification: 'Battery',
      id: 27,
    },
    [1 << 11]: {
      description: 'DCI is too high (DciOCP)',
      source: 'DCI',
      classification: 'Current',
      id: 28,
    },
    [1 << 12]: {
      description: 'Grid current is too high (SwOCPInstant)',
      source: 'Grid',
      classification: 'Current',
      id: 29,
    },
    [1 << 13]: {
      description: 'Current on Buck section is too high (BuckOCP)',
      source: 'Buck',
      classification: 'Current',
      id: 30,
    },
    [1 << 14]: {
      description: 'Output current is too high (AcRmsOCP)',
      source: 'Output',
      classification: 'Current',
      id: 31,
    },
    [1 << 15]: {
      description: 'Input current is too high (SwBOCPInstant)',
      source: 'Input',
      classification: 'Current',
      id: 32,
    },
  },
  3: {
    [1 << 0]: {
      description: 'Input mode is uncorrectly set (PvConfigSetWrong)',
      source: 'PV',
      classification: 'Configuration',
      id: 33,
    },
    [1 << 1]: {
      description: 'Overload protection (Overload)',
      source: 'System',
      classification: 'Protection',
      id: 34,
    },
    [1 << 2]: {
      description: 'CT error (CTDisconnect)',
      source: 'CT',
      classification: 'Hardware',
      id: 35,
    },
    // Bits 3 to 14 are reserved
    [1 << 15]: {
      description: 'GFCI Measured value by master and ID48 slave DSP is not matching (ConsistenFault)',
      source: 'Output',
      classification: 'Output',
      id: 48,
    },
  },
  4: {
    [1 << 0]: {
      description: 'Grid voltage value measured by master DSP and slave DSP is not consistent (ConsistentFault_Vgrid)',
      source: 'Grid',
      classification: 'Consistency',
      id: 49,
    },
    [1 << 1]: {
      description: 'Grid frequency value measured by master DSP and slave DSP is not consistent (ConsistentFault_Fgrid)',
      source: 'Grid',
      classification: 'Consistency',
      id: 50,
    },
    [1 << 2]: {
      description: 'DCI value measured by the master DSP and slave DSP is not consistent (ConsistentFault_DCI)',
      source: 'DCI',
      classification: 'Consistency',
      id: 51,
    },
    [1 << 3]: {
      description: 'Missing communication between inverter and batteries (BatCommunicationFlag)',
      source: 'Battery',
      classification: 'Communication',
      id: 52,
    },
    [1 << 4]: {
      description: 'The SPI communication between master DSP and slave DSP is faulty (SpiCommLose)',
      source: 'Communication',
      classification: 'Hardware',
      id: 53,
    },
    [1 << 5]: {
      description: 'The SCI communication between control board and communication board is faulty (SciCommLose)',
      source: 'Communication',
      classification: 'Hardware',
      id: 54,
    },
    [1 << 6]: {
      description: 'Relays fault (RecoverRelayFail)',
      source: 'Relay',
      classification: 'Hardware',
      id: 55,
    },
    [1 << 7]: {
      description: 'Insulation resistance is too low (PvIsoFault)',
      source: 'PV',
      classification: 'Resistance',
      id: 56,
    },
    [1 << 8]: {
      description: 'Battery temperature is too high (OverTempFault_BAT)',
      source: 'Battery',
      classification: 'Temperature',
      id: 57,
    },
    [1 << 9]: {
      description: 'Heatsink temperature is too high (OverTempFault_HeatSink)',
      source: 'Hardware',
      classification: 'Temperature',
    },
    [1 << 10]: {
      description: 'Environment temperature is too high (OverTempFault_Env)',
      source: 'Environment',
      classification: 'Temperature',
      id: 59,
    },
    [1 << 11]: {
      description: 'Grounding not correct (PE connectFault)',
      source: 'Ground',
      classification: 'Connection',
      id: 60,
    },
    // Bits 12 to 15 are reserved
  },
  5: {
    [1 << 0]: {
      description: 'Grid current is too high this caused unrecoverable hardware fault (UnrecoverHwAcOCP)',
      source: 'Grid',
      classification: 'Current',
      id: 65,
    },
    [1 << 1]: {
      description: 'Bus voltage is too high this caused unrecoverable hardware fault (UnrecoverBusOVP)',
      source: 'Bus',
      classification: 'Voltage',
      id: 66,
    },
    [1 << 2]: {
      description: 'Permanent battery overcurrent in EPS mode (BitEPSunrecoverBatOCP)',
      source: 'Battery',
      classification: 'Current',
      id: 67,
    },
    [1 << 3]: {
      description: 'Input current is unbalanced this caused unrecoverable hardware fault (UnrecoverIpvUnbalance)',
      source: 'Input',
      classification: 'Current',
      id: 68,
    },
    // Bit4 is reserved
    [1 << 5]: {
      description: 'Grid current is too high this caused unrecoverable hardware fault (UnrecoverOCPInstant)',
      source: 'Grid',
      classification: 'Current',
      id: 70,
    },
    // Bits 6 and 7 are reserved
    [1 << 8]: {
      description: 'Input mode is uncorrectly set (UnrecoverPVConfigSetWrong)',
      source: 'PV',
      classification: 'Configuration',
      id: 73,
    },
    [1 << 9]: {
      description: 'Input current is too high this caused unrecoverable hardware fault (UnrecoverIpvInstant)',
      source: 'Input',
      classification: 'Current',
      id: 74,
    },
    [1 << 10]: {
      description: 'The EEPROM is unrecoverable (UnrecoverWRITEEEPROM)',
      source: 'EEPROM',
      classification: 'Hardware',
      id: 75,
    },
    [1 << 11]: {
      description: 'The EEPROM is unrecoverable (UnrecoverREADEEPROM)',
      source: 'EEPROM',
      classification: 'Hardware',
      id: 76,
    },
    [1 << 12]: {
      description: 'Relay is in permanent fault (UnrecoverRelayFail)',
      source: 'Relay',
      classification: 'Hardware',
      id: 77,
    },
    // Bits 13 to 15 are reserved
  },
  6: {
    [1 << 0]: {
      description: 'Inverter derated because the temperature is too high (OverTempDerating)',
      source: 'Inverter',
      classification: 'Temperature',
      id: 81,
    },
    [1 << 1]: {
      description: 'Inverter derated because the grid frequency is too high (OverFreqDerating)',
      source: 'Inverter',
      classification: 'Frequency',
      id: 82,
    },
    [1 << 2]: {
      description: 'Inverter derated on remote control (RemoteDerating)',
      source: 'Remote',
      classification: 'Control',
      id: 83,
    },
    [1 << 3]: {
      description: 'Inverter shut down by remote control (RemoteOff)',
      source: 'Remote',
      classification: 'Control',
      id: 84,
    },
    [1 << 6]: {
      description: 'Battery voltage below SOC',
      source: 'Battery',
      classification: 'Battery',
      id: 85,
    },
    [1 << 7]: {
      description: 'Force charge failure',
      source: 'Charge',
      classification: 'Charge',
      id: 86,
    },
  },
  7: {
    // Bits 0 to 2 are reserved
    [1 << 3]: {
      description: 'Software version between control board and communication board is not consistent',
      source: 'Software',
      classification: 'Version',
      id: 94,
    },
    [1 << 4]: {
      description: 'Communication board EEPROM is faulty',
      source: 'EEPROM',
      classification: 'Hardware',
      id: 95,
    },
    [1 << 5]: {
      description: 'RTC clock chip is faulty (RTC clock chip anomaly)',
      source: 'RTC',
      classification: 'Hardware',
      id: 96,
    },
    [1 << 6]: {
      description: 'Selected country is Invalid (Invalid Country)',
      source: 'Configuration',
      classification: 'Setting',
      id: 97,
    },
    [1 << 7]: {
      description: 'The SD card is faulty (SD fault)',
      source: 'SD',
      classification: 'Storage',
      id: 98,
    },
  },
  8: {
    [1 << 0]: {
      description: 'Battery overcurrent (BatOCD)',
      source: 'Battery',
      classification: 'Battery',
      id: 100,
    },
    [1 << 1]: {
      description: 'Battery Short Circuit current protection (BatSCD)',
      source: 'Battery',
      classification: 'Protection',
      id: 101,
    },
    [1 << 2]: {
      description: 'Battery Overvoltage (BatOVP)',
      source: 'Battery',
      classification: 'Voltage',
      id: 102,
    },
    [1 << 3]: {
      description: 'Battery Undervoltage (BatUV)',
      source: 'Battery',
      classification: 'Voltage',
      id: 103,
    },
    [1 << 4]: {
      description: 'Battery Overtemperature during discharge (BatOTD)',
      source: 'Battery',
      classification: 'Temperature',
      id: 104,
    },
    [1 << 5]: {
      description: 'Battery Overtemperature during charge (BatOTC)',
      source: 'Battery',
      classification: 'Temperature',
      id: 105,
    },
    [1 << 6]: {
      description: 'Battery Undertemperature during discharge (BatUTD)',
      source: 'Battery',
      classification: 'Temperature',
      id: 106,
    },
    [1 << 7]: {
      description: 'Battery Undertemperature during charge (BatUTC)',
      source: 'Battery',
      classification: 'Temperature',
      id: 107,
    },
  },
};

export const faultsG1 = {
  1: {
    [1 << 0]: {
      id: 1,
      description: 'Grid voltage is too high (GridOVP)',
      source: 'Grid',
      classification: 'Grid',
    },
    [1 << 1]: {
      id: 2,
      description: 'Grid voltage is too low (GridUVP)',
      source: 'Grid',
      classification: 'Grid',
    },
    [1 << 2]: {
      id: 3,
      description: 'Grid frequency is too high (GridOFP)',
      source: 'Grid',
      classification: 'Grid',
    },
    [1 << 3]: {
      id: 4,
      description: 'Grid frequency is too low (GridUFP)',
      source: 'Grid',
      classification: 'Grid',
    },
    [1 << 4]: {
      id: 5,
      description: 'Input voltage is too low (PVUVP)',
      source: 'PV',
      classification: 'PV',
    },
    [1 << 5]: {
      id: 6,
      description: 'LVRT function is faulty (GridLVRT)',
      source: 'Grid',
      classification: 'Grid',
    },
    // Bits 6 and 7 are reserved
    [1 << 8]: {
      id: 9,
      description: 'Input voltage is too high (PVOVP)',
      source: 'PV',
      classification: 'PV',
    },
    [1 << 9]: {
      id: 10,
      description: 'Input current is not balanced (IpvUnbalance)',
      source: 'PV',
      classification: 'PV',
    },
    [1 << 10]: {
      id: 11,
      description: 'Incorrect input mode (PvConfigSetWrong)',
      source: 'PV',
      classification: 'PV',
    },
    [1 << 11]: {
      id: 12,
      description: 'GFCI Fault (GFCIFault)',
      source: 'GFCI',
      classification: 'GFCI',
    },
    [1 << 12]: {
      id: 13,
      description: 'Grid error (Grid Error)',
      source: 'Grid',
      classification: 'Grid',
    },
    [1 << 13]: {
      id: 14,
      description: 'Input current is too high (hardware overcurrent) (HwBoostOCP)',
      source: 'Hardware',
      classification: 'Hardware',
    },
    [1 << 14]: {
      id: 15,
      description: 'Grid current is too high (hardware overcurrent) (HwAcOCP)',
      source: 'Grid',
      classification: 'Hardware',
    },
    [1 << 15]: {
      id: 16,
      description: 'Grid current is too high (AcRmsOCP)',
      source: 'Grid',
      classification: 'Grid',
    },
  },
  2: {
    [1 << 0]: {
      id: 17,
      description: 'Grid current sampling error (HwADFaultIGrid)',
      source: 'Hardware',
      classification: 'Hardware',
    },
    [1 << 1]: {
      id: 18,
      description: 'DCI sampling error (HwADFaultDCI)',
      source: 'Hardware',
      classification: 'Hardware',
    },
    [1 << 2]: {
      id: 19,
      description: 'Grid voltage sampling error (HwADFaultVGrid)',
      source: 'Grid',
      classification: 'Hardware',
    },
    [1 << 3]: {
      id: 20,
      description: 'GFCI sampling error (GFCIDeviceFault)',
      source: 'GFCI',
      classification: 'GFCI',
    },
    [1 << 4]: {
      id: 21,
      description: 'Master chip fault (MChip_Fault)',
      source: 'Hardware',
      classification: 'Hardware',
    },
    [1 << 5]: {
      id: 22,
      description: 'Auxiliary voltage error (HwAuxPowerFault)',
      source: 'Hardware',
      classification: 'Hardware',
    },
    [1 << 6]: {
      id: 23,
      description: 'Bus voltage sampling error (BusVoltZeroFault)',
      source: 'Bus',
      classification: 'Hardware',
    },
    [1 << 7]: {
      id: 24,
      description: 'Output current is not balanced (IacRmsUnbalance)',
      source: 'Output',
      classification: 'Output',
    },
    [1 << 8]: {
      id: 25,
      description: 'Bus voltage is too low (BusUVP)',
      source: 'Bus',
      classification: 'Hardware',
    },
    [1 << 9]: {
      id: 26,
      description: 'Bus voltage is too high (BusOVP)',
      source: 'Bus',
      classification: 'Hardware',
    },
    [1 << 10]: {
      id: 27,
      description: 'Bus voltage is not balanced (VbusUnbalance)',
      source: 'Bus',
      classification: 'Hardware',
    },
    [1 << 11]: {
      id: 28,
      description: 'DCI is too high (DciOCP)',
      source: 'DCI',
      classification: 'Hardware',
    },
    [1 << 12]: {
      id: 29,
      description: 'Grid current is too high (SwOCPInstant)',
      source: 'Grid',
      classification: 'Grid',
    },
    [1 << 13]: {
      id: 30,
      description: 'Input current is too high (SwBOCPInstant)',
      source: 'Input',
      classification: 'Input',
    },
    // Bits 14 and 15 are reserved
  },
  3: {
    // Bits 0 to 7 are reserved for Byte4 and Byte5
    [1 << 8]: {
      id: 49,
      description: 'Grid voltage value measured by master DSP and slave DSP is not consistent (ConsistentFault_VGrid)',
      source: 'Grid',
      classification: 'Hardware',
    },
    [1 << 9]: {
      id: 50,
      description: 'Grid frequency value measured by master DSP and slave DSP is not consistent (ConsistentFault_FGrid)',
      source: 'Grid',
      classification: 'Hardware',
    },
    [1 << 10]: {
      id: 51,
      description: 'DCI value measured by the master DSP and slave DSP is not consistent (ConsistentFault_DCI)',
      source: 'DCI',
      classification: 'Hardware',
    },
    [1 << 11]: {
      id: 52,
      description: 'GFCI value measured by master DSP and slave DSP is not consistent (ConsistentFault_GFCI)',
      source: 'GFCI',
      classification: 'GFCI',
    },
    [1 << 12]: {
      id: 52,
      description: 'The SPI communication between master DSP and slave DSP is faulty (SpiCommLose)',
      source: 'Communication',
      classification: 'Hardware',
    },
    [1 << 13]: {
      id: 53,
      description: 'The SCI communication between control board and communication board is faulty (SciCommLose)',
      source: 'Communication',
      classification: 'Hardware',
    },
    [1 << 14]: {
      id: 54,
      description: 'Relays fault (RelayTestFail)',
      source: 'Relay',
      classification: 'Hardware',
    },
    [1 << 15]: {
      id: 55,
      description: 'Insulation resistance is too low (PvIsoFault)',
      source: 'Insulation',
      classification: 'Protection',
    },
  },
  4: {
    [1 << 0]: {
      id: 57,
      description: 'The inverter temp is too high (OverTempFault_Inv)',
      source: 'Inverter',
      classification: 'Hardware',
    },
    [1 << 1]: {
      id: 58,
      description: 'Boost temperature is too high (OverTempFault_Boost)',
      source: 'Boost',
      classification: 'Hardware',
    },
    [1 << 2]: {
      id: 59,
      description: 'Environment temperature is too high (OverTempFault_Env)',
      source: 'Environment',
      classification: 'Environment',
    },
    [1 << 3]: {
      id: 60,
      description: 'Grounding not correct (PEConnectFault)',
      source: 'Grounding',
      classification: 'Protection',
    },
    [1 << 4]: {
      id: 61,
      description: 'The inverter temperature is too high (INVTempDiffFault)',
      source: 'Inverter',
      classification: 'Hardware',
    },
    // Bits 5 to 7 are reserved
    [1 << 8]: {
      id: 65,
      description: 'Grid current is too high this caused unrecoverable hardware fault (unrecoverHwAcOCP)',
      source: 'Grid',
      classification: 'Hardware',
    },
    [1 << 9]: {
      id: 66,
      description: 'Bus voltage is too high this caused unrecoverable hardware fault (unrecoverBusOVP)',
      source: 'Bus',
      classification: 'Hardware',
    },
    [1 << 10]: {
      id: 67,
      description: 'Grid current is unbalanced this caused unrecoverable hardware fault (unrecoverIacRmsUnbalance)',
      source: 'Grid',
      classification: 'Hardware',
    },
    [1 << 11]: {
      id: 68,
      description: 'Input current is unbalanced this caused unrecoverable hardware fault (unrecoverIpvUnbalance)',
      source: 'Input',
      classification: 'Hardware',
    },
    [1 << 12]: {
      id: 69,
      description: 'Bus voltage is unbalanced this caused unrecoverable hardware fault (unrecoverVbusUnbalance)',
      source: 'Bus',
      classification: 'Hardware',
    },
    [1 << 13]: {
      id: 70,
      description: 'Grid current is too high this caused unrecoverable hardware fault (unrecoverOCPInstant)',
      source: 'Grid',
      classification: 'Hardware',
    },
    [1 << 14]: {
      id: 71,
      description: 'Incorrect input mode (unrecoverPvConfigSetWrong)',
      source: 'Input',
      classification: 'PV',
    },
    // Bit 15 is reserved
  },
  5: {
    // Bit 0 is reserved
    [1 << 1]: {
      id: 74,
      description: 'Input current is too high this caused unrecoverable hardware fault (unrecoverIPVInstant)',
      source: 'Input',
      classification: 'PV',
    },
    [1 << 2]: {
      id: 75,
      description: 'The EEPROM is unrecoverable (unrecoverWRITEEEPROM)',
      source: 'EEPROM',
      classification: 'Hardware',
    },
    [1 << 3]: {
      id: 76,
      description: 'The EEPROM is unrecoverable (unrecoverREADEEPROM)',
      source: 'EEPROM',
      classification: 'Hardware',
    },
    [1 << 4]: {
      id: 77,
      description: 'Relay is in permanent fault (unrecoverRelayFail)',
      source: 'Relay',
      classification: 'Hardware',
    },
    // Bits 5 to 7 are reserved
  },
  6: {
    [1 << 0]: {
      id: 81,
      description: 'Inverter derated because the temperature is too high (OverTempDerating)',
      source: 'Inverter',
      classification: 'Temperature',
    },
    [1 << 1]: {
      id: 82,
      description: 'Inverter derated because the grid frequency is too high (OverFreqDerating)',
      source: 'Inverter',
      classification: 'Frequency',
    },
    [1 << 2]: {
      id: 83,
      description: 'Inverter derated on remote control (RemoteDerating)',
      source: 'Remote',
      classification: 'Control',
    },
    [1 << 3]: {
      id: 84,
      description: 'Inverter shut down by remote control (RemoteOff)',
      source: 'Remote',
      classification: 'Control',
    },
    [1 << 4]: {
      id: 85,
      description: 'Inverter derated because the grid frequency is too low (UnderFreqDerate)',
      source: 'Inverter',
      classification: 'Frequency',
    },
    // Bits 5 and 6 are reserved
    [1 << 7]: {
      id: 89,
      description: 'Derating for antireflux (RefluxDerating)',
      source: 'Reflux',
      classification: 'Derating',
    },
  },
  7: {
    [1 << 0]: {
      id: 90,
      description: 'Fan #1 fault (Fan1 alarm)',
      source: 'Fan',
      classification: 'Hardware',
    },
    [1 << 1]: {
      id: 91,
      description: 'Fan #2 fault (Fan2 alarm)',
      source: 'Fan',
      classification: 'Hardware',
    },
    [1 << 2]: {
      id: 92,
      description: 'Lightning protection tripped (Lightning protection alarm)',
      source: 'Protection',
      classification: 'Safety',
    },
    [1 << 3]: {
      id: 93,
      description: 'Software version between control board and communication board is not consistent',
      source: 'Software',
      classification: 'Version',
    },
    [1 << 4]: {
      id: 94,
      description: 'Communication board EEPROM is faulty',
      source: 'EEPROM',
      classification: 'Hardware',
    },
    [1 << 5]: {
      id: 95,
      description: 'RTC clock chip is faulty (RTC clock chip anomaly)',
      source: 'RTC',
      classification: 'Hardware',
    },
    [1 << 6]: {
      id: 96,
      description: 'Selected country is Invalid (InValidCountry)',
      source: 'Configuration',
      classification: 'Setting',
    },
    [1 << 7]: {
      id: 97,
      description: 'The SD card is faulty (SDfault)',
      source: 'SD',
      classification: 'Storage',
    },
    [1 << 8]: {
      id: 90,
      description: 'Fan #3 fault (Fan3 alarm)',
      source: 'Fan',
      classification: 'Hardware',
    },
    [1 << 9]: {
      id: 86,
      description: 'WIFI fault alarm (WifiFault)',
      source: 'WIFI',
      classification: 'Communication',
    },
    [1 << 10]: {
      id: 87,
      description: 'Fan #4 fault (Fan4 alarm)',
      source: 'Fan',
      classification: 'Hardware',
    },
    [1 << 11]: {
      id: 88,
      description: 'Fan #5 fault (Fan5 alarm)',
      source: 'Fan',
      classification: 'Hardware',
    },
    // Bits 12 to 15 are reserved
  },
};

export const bmsFaults: ErrorCatalog = {
  [0x9076]: {
    [1 << 0]: {
      description: 'Battery Charge High Temperature Warning',
      source: 'Battery',
      classification: 'Alarm',
    },
    [1 << 1]: {
      description: 'Battery Discharge High Temperature Warning',
      source: 'Battery',
      classification: 'Alarm',
    },
    [1 << 2]: {
      description: 'Battery Charge Low Temperature Warning',
      source: 'Battery',
      classification: 'Alarm',
    },
    [1 << 3]: {
      description: 'Battery Discharge Low Temperature Warning',
      source: 'Battery',
      classification: 'Alarm',
    },
    [1 << 4]: {
      description: 'BMS Environment High Temperature Warning',
      source: 'BMS',
      classification: 'Alarm',
    },
    [1 << 5]: {
      description: 'BMS Environment Low Temperature Warning',
      source: 'BMS',
      classification: 'Alarm',
    },
    [1 << 6]: {
      description: 'MOS Over Temperature Warning',
      source: 'Hardware',
      classification: 'Alarm',
    },
    [1 << 7]: {
      description: 'Low Battery Warning',
      source: 'Battery',
      classification: 'Alarm',
    },
    [1 << 8]: {
      description: 'Single-cell Overvoltage Warning',
      source: 'Cell',
      classification: 'Alarm',
    },
    [1 << 9]: {
      description: 'Single-cell Undervoltage Warning',
      source: 'Cell',
      classification: 'Alarm',
    },
    [1 << 10]: {
      description: 'Total Voltage Overvoltage Warning',
      source: 'Battery',
      classification: 'Alarm',
    },
    [1 << 11]: {
      description: 'Total Voltage Undervoltage Warning',
      source: 'Battery',
      classification: 'Alarm',
    },
    [1 << 12]: {
      description: 'Charge Overcurrent Warning',
      source: 'Current',
      classification: 'Alarm',
    },
    [1 << 13]: {
      description: 'Discharge Overcurrent Warning',
      source: 'Current',
      classification: 'Alarm',
    },
  },
  [0x9077]: {
    [1 << 0]: {
      description: 'Charging High Temperature Protection (Cells)',
      source: 'Battery',
      classification: 'Protection',
    },
    [1 << 1]: {
      description: 'Discharge High Temperature Protection (Cells)',
      source: 'Battery',
      classification: 'Protection',
    },
    [1 << 2]: {
      description: 'Charging Low Temperature Protection (Cells)',
      source: 'Battery',
      classification: 'Protection',
    },
    [1 << 3]: {
      description: 'Discharge Cryoprotection (Cells)',
      source: 'Battery',
      classification: 'Protection',
    },
    [1 << 4]: {
      description: 'MOS High Temperature Protection',
      source: 'Hardware',
      classification: 'Protection',
    },
    [1 << 5]: {
      description: 'Environmental High Temperature Protection',
      source: 'Environment',
      classification: 'Protection',
    },
    [1 << 6]: {
      description: 'Environmental Low Temperature Protection',
      source: 'Environment',
      classification: 'Protection',
    },
    [1 << 7]: {
      description: 'Battery Fully Charged',
      source: 'Battery',
      classification: 'Protection',
    },
    [1 << 8]: {
      description: 'Cell Overvoltage Protection',
      source: 'Cell',
      classification: 'Protection',
    },
    [1 << 9]: {
      description: 'Cell Undervoltage Protection',
      source: 'Cell',
      classification: 'Protection',
    },
    [1 << 10]: {
      description: 'Total Voltage Overvoltage Protection',
      source: 'Battery',
      classification: 'Protection',
    },
    [1 << 11]: {
      description: 'Total Voltage Undervoltage Protection',
      source: 'Battery',
      classification: 'Protection',
    },
    [1 << 12]: {
      description: 'Charge Overcurrent Protection',
      source: 'Current',
      classification: 'Protection',
    },
    [1 << 13]: {
      description: 'Discharge Overcurrent Protection',
      source: 'Current',
      classification: 'Protection',
    },
    [1 << 14]: {
      description: 'Short Circuit Protection',
      source: 'Circuit',
      classification: 'Protection',
    },
  },
  [0x9078]: {
    [1 << 0]: {
      description: 'Discharge MOS Failure',
      source: 'Hardware',
      classification: 'Fault',
    },
    [1 << 1]: {
      description: 'Charging MOS Failure',
      source: 'Hardware',
      classification: 'Fault',
    },
    [1 << 2]: {
      description: 'NTC Failure',
      source: 'Sensor',
      classification: 'Fault',
    },
    [1 << 3]: {
      description: 'Auxiliary Source Voltage Abnormality',
      source: 'Power Supply',
      classification: 'Fault',
    },
    [1 << 4]: {
      description: 'Battery Pack Failure',
      source: 'Battery',
      classification: 'Fault',
    },
    [1 << 5]: {
      description: 'Sampling Fault',
      source: 'Measurement',
      classification: 'Fault',
    },
    [1 << 6]: {
      description: 'Current Limiting Circuit Boards Failure',
      source: 'Circuit Board',
      classification: 'Fault',
    },
  },
  [0x9014]: {
    [1 << 0]: {
      description: 'Cell Undervoltage Protection',
      source: 'Cell',
      classification: 'Protection',
    },
    [1 << 1]: {
      description: 'Cell Overvoltage Protection',
      source: 'Cell',
      classification: 'Protection',
    },
    [1 << 2]: {
      description: 'Total Voltage Undervoltage Protection',
      source: 'Battery',
      classification: 'Protection',
    },
    [1 << 3]: {
      description: 'Total Voltage Overvoltage Protection',
      source: 'Battery',
      classification: 'Protection',
    },
    [1 << 4]: {
      description: 'Charging Low Temperature Protection (Cells)',
      source: 'Battery',
      classification: 'Protection',
    },
    [1 << 5]: {
      description: 'Charging High Temperature Protection (Cells)',
      source: 'Battery',
      classification: 'Protection',
    },
    [1 << 6]: {
      description: 'Discharge Cryoprotection (Cells)',
      source: 'Battery',
      classification: 'Protection',
    },
    [1 << 7]: {
      description: 'Discharge High Temperature Protection (Cells)',
      source: 'Battery',
      classification: 'Protection',
    },
    [1 << 8]: {
      description: 'Charge Overcurrent Protection',
      source: 'Current',
      classification: 'Protection',
    },
    [1 << 9]: {
      description: 'Discharge Overcurrent Protection',
      source: 'Current',
      classification: 'Protection',
    },
  },
  [0x9015]: {
    [1 << 0]: {
      description: 'PCU Permanent Failure',
      source: 'PCU',
      classification: 'Fault',
    },
    [1 << 1]: {
      description: 'Short Circuit Protection',
      source: 'Circuit',
      classification: 'Protection',
    },
    [1 << 2]: {
      description: 'CAN ID Conflict',
      source: 'Communication',
      classification: 'Fault',
    },
    [1 << 4]: {
      description: 'Environmental High Temperature Protection',
      source: 'Environment',
      classification: 'Protection',
    },
    [1 << 5]: {
      description: 'Environmental Low Temperature Protection',
      source: 'Environment',
      classification: 'Protection',
    },
    [1 << 6]: {
      description: 'Discharge MOS Failure',
      source: 'Hardware',
      classification: 'Fault',
    },
    [1 << 7]: {
      description: 'Charging MOS Failure',
      source: 'Hardware',
      classification: 'Fault',
    },
    [1 << 9]: {
      description: 'NTC Failure',
      source: 'Sensor',
      classification: 'Fault',
    },
    [1 << 10]: {
      description: 'Sampling Fault',
      source: 'Measurement',
      classification: 'Fault',
    },
    [1 << 11]: {
      description: 'Battery Pack Failure',
      source: 'Battery',
      classification: 'Fault',
    },
  },
  [0x9016]: {
    [1 << 8]: {
      description: 'Single-cell Undervoltage Warning',
      source: 'Cell',
      classification: 'Alarm',
    },
    [1 << 9]: {
      description: 'Single-cell Overvoltage Warning',
      source: 'Cell',
      classification: 'Alarm',
    },
    [1 << 10]: {
      description: 'Total Voltage Undervoltage Warning',
      source: 'Battery',
      classification: 'Alarm',
    },
    [1 << 11]: {
      description: 'Total Voltage Overvoltage Warning',
      source: 'Battery',
      classification: 'Alarm',
    },
    [1 << 12]: {
      description: 'Battery Charge Low Temperature Warning',
      source: 'Battery',
      classification: 'Alarm',
    },
    [1 << 13]: {
      description: 'Battery Charge High Temperature Warning',
      source: 'Battery',
      classification: 'Alarm',
    },
    [1 << 14]: {
      description: 'Battery Discharge Low Temperature Warning',
      source: 'Battery',
      classification: 'Alarm',
    },
    [1 << 15]: {
      description: 'Battery Discharge High Temperature Warning',
      source: 'Battery',
      classification: 'Alarm',
    },
  },
  [0x9017]: {
    [1 << 0]: {
      description: 'Charge Overcurrent Warning',
      source: 'Current',
      classification: 'Alarm',
    },
    [1 << 1]: {
      description: 'Discharge Overcurrent Warning',
      source: 'Current',
      classification: 'Alarm',
    },
    [1 << 2]: {
      description: 'Total Voltage Undervoltage Warning',
      source: 'Battery',
      classification: 'Alarm',
    },
    [1 << 3]: {
      description: 'Total Voltage Overvoltage Warning',
      source: 'Battery',
      classification: 'Alarm',
    },
    [1 << 4]: {
      description: 'Low Battery Warning',
      source: 'Battery',
      classification: 'Alarm',
    },
    [1 << 10]: {
      description: 'BMS Environment High Temperature Warning',
      source: 'BMS',
      classification: 'Alarm',
    },
    [1 << 11]: {
      description: 'BMS Environment Low Temperature Warning',
      source: 'BMS',
      classification: 'Alarm',
    },
  },
};

/**
 * Faults 800 - 927
 */
export const pcuWarningsFaults: ErrorCatalog = {
  [0x6024]: {
    [1 << 1]: {
      description: 'Charging Soft Start Failure',
      source: 'PCU',
      classification: 'Warning',
      warning: 'Failure in soft start during charging process.'
    },
    [1 << 2]: {
      description: 'Discharging Soft Start Failure',
      source: 'PCU',
      classification: 'Warning',
      warning: 'Failure in soft start during discharging process.'
    },
    [1 << 3]: {
      description: 'Fan 1 Fault',
      source: 'Fan',
      classification: 'Warning',
      warning: 'Fan 1 malfunction.'
    },
    [1 << 4]: {
      description: 'Fan 2 Fault',
      source: 'Fan',
      classification: 'Warning',
      warning: 'Fan 2 malfunction.'
    },
    [1 << 5]: {
      description: 'Fan 3 Fault',
      source: 'Fan',
      classification: 'Warning',
      warning: 'Fan 3 malfunction.'
    },
    [1 << 6]: {
      description: 'Fan 4 Fault',
      source: 'Fan',
      classification: 'Warning',
      warning: 'Fan 4 malfunction.'
    },
    [1 << 7]: {
      description: 'PCU Version Inconsistency',
      source: 'PCU',
      classification: 'Warning',
      warning: 'Mismatch in PCU version detected.'
    },
    [1 << 8]: {
      description: 'Heatsink 1 High Temperature Warning',
      source: 'Heatsink',
      classification: 'Warning',
      warning: 'High temperature warning for heatsink 1.'
    },
    [1 << 9]: {
      description: 'Environmental High Temperature Warning',
      source: 'Environment',
      classification: 'Warning',
      warning: 'High environmental temperature warning.'
    },
    [1 << 10]: {
      description: 'Heatsink 2 High Temperature Warning',
      source: 'Heatsink',
      classification: 'Warning',
      warning: 'High temperature warning for heatsink 2.'
    },
    [1 << 13]: {
      description: 'Stop Charging Warning',
      source: 'PCU',
      classification: 'Warning',
      warning: 'Warning to stop charging.'
    },
    [1 << 14]: {
      description: 'Stop Discharging Warning',
      source: 'PCU',
      classification: 'Warning',
      warning: 'Warning to stop discharging.'
    },
    [1 << 15]: {
      description: 'Battery Unbalance Warning',
      source: 'Battery',
      classification: 'Warning',
      warning: 'Warning of battery unbalance.'
    },
  },
  [0x6025]: {
    [1 << 0]: {
      description: 'Bus Overvoltage Warning',
      source: 'Bus',
      classification: 'Warning',
      warning: 'Overvoltage warning on the bus.'
    },
    [1 << 1]: {
      description: 'Bus Undervoltage Warning',
      source: 'Bus',
      classification: 'Warning',
      warning: 'Undervoltage warning on the bus.'
    },
    [1 << 2]: {
      description: 'Battery Overvoltage Warning',
      source: 'Battery',
      classification: 'Warning',
      warning: 'Overvoltage warning for the battery.'
    },
    [1 << 3]: {
      description: 'Battery Undervoltage Warning',
      source: 'Battery',
      classification: 'Warning',
      warning: 'Undervoltage warning for the battery.'
    },
  },
  [0x6028]: {
    [1 << 0]: {
      description: 'Heatsink 1 Over Temperature Fault',
      source: 'Heatsink',
      classification: 'Fault',
      warning: 'Over temperature fault in heatsink 1.'
    },
    [1 << 1]: {
      description: 'Environmental Over Temperature Fault',
      source: 'Environment',
      classification: 'Fault',
      warning: 'Over temperature fault in environmental conditions.'
    },
    [1 << 2]: {
      description: 'SCI Communication Fault',
      source: 'Communication',
      classification: 'Fault',
      warning: 'Communication fault in SCI.'
    },
    [1 << 3]: {
      description: 'CAN1 Communication Fault',
      source: 'Communication',
      classification: 'Fault',
      warning: 'Communication fault in CAN1.'
    },
    [1 << 4]: {
      description: 'Relay 1 Failure',
      source: 'Relay',
      classification: 'Fault',
      warning: 'Failure in relay 1.'
    },
    [1 << 5]: {
      description: 'Heatsink 2 Over Temperature Fault',
      source: 'Heatsink',
      classification: 'Fault',
      warning: 'Over temperature fault in heatsink 2.'
    },
    [1 << 6]: {
      description: 'CAN2 Communication Fault',
      source: 'Communication',
      classification: 'Fault',
      warning: 'Communication fault in CAN2.'
    },
    [1 << 7]: {
      description: 'Relay 2 Failure',
      source: 'Relay',
      classification: 'Fault',
      warning: 'Failure in relay 2.'
    },
    [1 << 8]: {
      description: 'Software Bus Overvoltage',
      source: 'Bus',
      classification: 'Fault',
      warning: 'Immediate overvoltage condition detected on the bus by software.'
    },
    [1 << 9]: {
      description: 'Software Bus Undervoltage',
      source: 'Bus',
      classification: 'Fault',
      warning: 'Immediate undervoltage condition detected on the bus by software.'
    },
    [1 << 10]: {
      description: 'Software Battery Overvoltage',
      source: 'Battery',
      classification: 'Fault',
      warning: 'Immediate overvoltage condition detected on the battery by software.'
    },
    [1 << 11]: {
      description: 'Software Battery Undervoltage',
      source: 'Battery',
      classification: 'Fault',
      warning: 'Immediate undervoltage condition detected on the battery by software.'
    },
    [1 << 12]: {
      description: 'Software Battery Overcurrent',
      source: 'Battery',
      classification: 'Fault',
      warning: 'Immediate overcurrent condition detected on the battery by software.'
    },
    [1 << 13]: {
      description: 'Flying Capacitor 1 Overvoltage',
      source: 'Capacitor',
      classification: 'Fault',
      warning: 'Overvoltage detected in flying capacitor 1.'
    },
    [1 << 14]: {
      description: 'Flying Capacitor 2 Overvoltage',
      source: 'Capacitor',
      classification: 'Fault',
      warning: 'Overvoltage detected in flying capacitor 2.'
    },
    [1 << 15]: {
      description: 'Hardware Overcurrent Protection',
      source: 'Hardware',
      classification: 'Fault',
      warning: 'Hardware level overcurrent protection triggered.'
    },
  },
  [0x6029]: {
    [1 << 0]: {
      description: 'Unrecoverable Bus Overvoltage',
      source: 'Bus',
      classification: 'Fault',
      warning: 'Permanent overvoltage condition on the bus.'
    },
    [1 << 1]: {
      description: 'Unrecoverable Battery Undervoltage',
      source: 'Battery',
      classification: 'Fault',
      warning: 'Permanent undervoltage condition on the battery.'
    },
    [1 << 2]: {
      description: 'Unrecoverable Overcurrent Instant',
      source: 'Current',
      classification: 'Fault',
      warning: 'Permanent instant overcurrent condition.'
    },
    [1 << 3]: {
      description: 'Unrecoverable Hardware Overcurrent Protection',
      source: 'Hardware',
      classification: 'Fault',
      warning: 'Irreversible hardware overcurrent protection triggered.'
    },
    [1 << 4]: {
      description: 'Flying Capacitor 3 Overvoltage',
      source: 'Capacitor',
      classification: 'Fault',
      warning: 'Overvoltage detected in flying capacitor 3.'
    },
    [1 << 5]: {
      description: 'Flying Capacitor 4 Overvoltage',
      source: 'Capacitor',
      classification: 'Fault',
      warning: 'Overvoltage detected in flying capacitor 4.'
    },
    [1 << 6]: {
      description: 'Flying Capacitor 1 Undervoltage',
      source: 'Capacitor',
      classification: 'Fault',
      warning: 'Undervoltage detected in flying capacitor 1.'
    },
    [1 << 7]: {
      description: 'Flying Capacitor 2 Undervoltage',
      source: 'Capacitor',
      classification: 'Fault',
      warning: 'Undervoltage detected in flying capacitor 2.'
    },

    [1 << 8]: {
      description: 'Unrecoverable Relay 1 Failure',
      source: 'Relay',
      classification: 'Fault',
      warning: 'Permanent failure in relay 1.'
    },
    [1 << 9]: {
      description: 'Unrecoverable Relay 2 Failure',
      source: 'Relay',
      classification: 'Fault',
      warning: 'Permanent failure in relay 2.'
    },
    [1 << 10]: {
      description: 'Flying Capacitor 3 Undervoltage',
      source: 'Capacitor',
      classification: 'Fault',
      warning: 'Undervoltage detected in flying capacitor 3.'
    },
    [1 << 11]: {
      description: 'Flying Capacitor 4 Undervoltage',
      source: 'Capacitor',
      classification: 'Fault',
      warning: 'Undervoltage detected in flying capacitor 4.'
    },
    [1 << 13]: {
      description: 'Unrecoverable Bus Short Circuit Protection',
      source: 'Bus',
      classification: 'Fault',
      warning: 'Permanent bus short circuit protection triggered.'
    },
    [1 << 14]: {
      description: 'Unrecoverable Battery Activation Failure',
      source: 'Battery',
      classification: 'Fault',
      warning: 'Permanent battery activation failure.'
    },
    [1 << 15]: {
      description: 'Unrecoverable Bus Reverse Polarity Protection',
      source: 'Bus',
      classification: 'Fault',
      warning: 'Permanent bus reverse polarity protection.'
    },
  },
  [0x602A]: {
    [1 << 0]: {
      description: 'Battery State Error',
      source: 'Battery',
      classification: 'Fault',
      warning: 'Error detected in battery state.'
    },
    [1 << 1]: {
      description: 'PWM Mode Error',
      source: 'Controller',
      classification: 'Fault',
      warning: 'Error detected in PWM mode operation.'
    },
    [1 << 2]: {
      description: 'BMS Version Error',
      source: 'BMS',
      classification: 'Fault',
      warning: 'Mismatch or error in BMS firmware version.'
    },
    [1 << 3]: {
      description: 'BMS Overvoltage or Overcurrent Fault',
      source: 'BMS',
      classification: 'Fault',
      warning: 'Overvoltage or overcurrent condition detected by the BMS.'
    },
    [1 << 4]: {
      description: 'Software Battery Average Overcurrent Protection',
      source: 'Battery',
      classification: 'Fault',
      warning: 'Software detected overcurrent condition averaged over the battery.'
    },
    [1 << 5]: {
      description: 'Software Average Overload Protection',
      source: 'Power System',
      classification: 'Fault',
      warning: 'Average overload condition detected by software.'
    },
    [1 << 6]: {
      description: 'Bus bar software over current',
      source: 'Circuit',
      classification: 'Fault',
      warning: 'Overcurrent protection triggered in CBC by software.'
    },
    [1 << 7]: {
      description: 'Software CBC Overcurrent Protection',
      source: 'Circuit',
      classification: 'Fault',
      warning: 'Overcurrent protection triggered in CBC by software.'
    },
    [1 << 8]: {
      description: 'Pack ID error',
      source: 'Circuit',
      classification: 'Fault',
      warning: 'Overcurrent protection triggered in CBC by software.'
    },
    [1 << 9]: {
      description: 'Startup bus bar short circuit protection',
      source: 'Circuit',
      classification: 'Fault',
      warning: 'Overcurrent protection triggered in CBC by software.'
    },
    [1 << 10]: {
      description: 'Bus bar average under voltage',
      source: 'Circuit',
      classification: 'Fault',
      warning: 'Overcurrent protection triggered in CBC by software.'
    },
    [1 << 11]: {
      description: 'Chip clock fault',
      source: 'Circuit',
      classification: 'Fault',
      warning: 'Overcurrent protection triggered in CBC by software.'
    },
    [1 << 12]: {
      description: 'Inverter CAN communication fault',
      source: 'Circuit',
      classification: 'Fault',
      warning: 'Overcurrent protection triggered in CBC by software.'
    },
    [1 << 13]: {
      description: 'Radiator low temperature fault',
      source: 'Circuit',
      classification: 'Fault',
      warning: 'Overcurrent protection triggered in CBC by software.'
    },
    [1 << 14]: {
      description: 'Environment low temperature fault',
      source: 'Environment',
      classification: 'Fault',
      warning: 'Low ambient temperature fault detected.'
    },
    [1 << 15]: {
      description: 'Sampling bias calibration fault',
      source: 'Hardware',
      classification: 'Fault',
      warning: 'Sampling offset calibration failure detected.'
    },
  },
};

export const bduFaults: ErrorCatalog = {
  [0x609F]: {
    [1 << 0]: {
      description: 'Battery Reverse Connection',
      source: 'Battery',
      classification: 'Fault',
      warning: 'Battery is connected in reverse.'
    },
    [1 << 1]: {
      description: 'Fuse Fault',
      source: 'Fuse',
      classification: 'Fault',
      warning: 'Fault detected in the fuse.'
    },
  }
};

export const faultsG3: ErrorCatalog = {
  1: {
    [1 << 0]: {
      description: '001 Grid Overvoltage',
      level: 2,
      source: 'DSPM',
      classification: 'Grid',
    },
    [1 << 1]: {
      description: '002 Grid Undervoltage',
      level: 2,
      source: 'DSPM',
      classification: 'Grid',
    },
    [1 << 2]: {
      description: '003 Grid Overfrequency',
      level: 2,
      source: 'DSPM',
      classification: 'Grid',
    },
    [1 << 3]: {
      description: '004 Grid Underfrequency',
      level: 2,
      source: 'DSPM',
      classification: 'Grid',
    },
    [1 << 4]: {
      description: '005 Leakage Current Fault',
      level: 2,
      source: 'DSPM&S',
      classification: 'Grid',
    },
    [1 << 5]: {
      description: '006 High Penetration Error',
      level: 2,
      source: 'DSPM',
      classification: 'Grid',
    },
    [1 << 6]: {
      description: '007 Low Penetration Error',
      level: 2,
      source: 'DSPM',
      classification: 'Grid',
    },
    [1 << 7]: {
      description: '008 Island Error',
      level: 2,
      source: 'DSPM',
      classification: 'Grid',
    },
    [1 << 8]: {
      description: '009 Grid Voltage Instantaneous Value Overvoltage 1',
      level: 2,
      source: 'DSPM',
      classification: 'Grid',
    },
    [1 << 9]: {
      description: '010 Grid Voltage Instantaneous Value Overvoltage 2',
      level: 2,
      source: 'DSPM',
      classification: 'Grid',
    },
    [1 << 10]: {
      description: '011 Grid Line Voltage Error',
      level: 2,
      source: 'DSPM',
      classification: 'Grid',
    },
    [1 << 11]: {
      description: '012 Inverter Overvoltage',
      level: 2,
      source: 'DSPM',
      classification: 'Grid',
    },
    [1 << 12]: {
      description: '013 Anti-backflow Overload',
      level: 2,
      source: 'DSPM&S',
      classification: 'Grid',
    },
    [1 << 13]: {
      description: '014 Grid Voltage Unbalance',
      level: 2,
      source: 'DSPM',
      classification: 'Grid',
    },
    [1 << 14]: {
      description: '015 Inverter Transient Overvoltage',
      level: 2,
      source: 'DSPM',
      classification: 'Grid',
    },
    [1 << 15]: {
      description: '016 Sudden Grid Phase Change',
      level: 2,
      source: 'DSPM',
      classification: 'Grid',
    },
  },
  2: {
    [1 << 0]: {
      description: 'Grid current sampling error',
      source: 'DSPM',
      classification: 'Sampling error',
    },
    [1 << 1]: {
      description: 'DCI Sampling Error (AC)',
      source: 'DSPM',
      classification: 'Sampling error',
    },
    [1 << 2]: {
      description: 'Network voltage sampling error (DC)',
      source: 'DSPS',
      classification: 'Sampling error',
    },
    [1 << 3]: {
      description: 'Network voltage sampling error (AC)',
      source: 'DSPM',
      classification: 'Sampling error',
    },
    [1 << 4]: {
      description: 'GFCI sampling error (DC)',
      source: 'DSPS',
      classification: 'Sampling error',
    },
    [1 << 5]: {
      description: 'GFCI sampling error (AC)',
      source: 'DSPM',
      classification: 'Sampling error',
    },
    [1 << 6]: {
      description: 'DCV sampling error',
      source: 'DSPM',
      classification: 'Sampling error',
    },
    [1 << 7]: {
      description: 'Input current sampling error',
      source: 'DSPS',
      classification: 'Sampling error',
    },
    [1 << 8]: {
      description: 'DCI sampling error (DC)',
      source: 'DSPS',
      classification: 'Sampling error',
    },
    [1 << 9]: {
      description: 'Branch current sampling error',
      source: 'DSPS',
      classification: 'Sampling error',
    },
    [1 << 10]: {
      description: 'PV low impedance to ground',
      source: 'DSPS',
      classification: 'System error',
    },
    [1 << 11]: {
      description: 'PID abnormal output',
      source: 'DSPM',
      classification: 'System error',
    },
    [1 << 12]: {
      description: 'Leakage current consistency error',
      source: 'DSPS',
      classification: 'System error',
    },
    [1 << 13]: {
      description: 'Network voltage consistency error',
      source: 'DSPS',
      classification: 'System error',
    },
    [1 << 14]: {
      description: 'DCI consistency error',
      source: 'DSPS',
      classification: 'System error',
    },
    [1 << 15]: {
      description: 'Neutral ground fault',
      source: 'DSPS',
      classification: 'System error',
    }
  },
  3: {
    [1 << 0]: {
      description: 'SPI communication error (DC)',
      source: 'DSPM',
      classification: 'Communication error',
    },
    [1 << 1]: {
      description: 'SPI communication error (AC)',
      source: 'DSPM',
      classification: 'Communication error',
    },
    [1 << 2]: {
      description: 'Chip error (DC)',
      source: 'DSPM',
      classification: 'Hardware error',
    },
    [1 << 3]: {
      description: 'Chip error (AC)',
      source: 'DSPM',
      classification: 'Hardware error',
    },
    [1 << 4]: {
      description: 'Auxiliary power error',
      source: 'DSPM',
      classification: 'Power error',
    },
    [1 << 5]: {
      description: 'Inverter soft start failure',
      source: 'DSPM',
      classification: 'System error',
    },
    [1 << 6]: {
      description: 'Arc shutdown protection',
      source: 'DSPM',
      classification: 'Safety error',
    },
    [1 << 7]: {
      description: 'Weak light detection failure',
      source: 'DSPM',
      classification: 'System error',
    },
    [1 << 8]: {
      description: 'Relay detection failure',
      source: 'DSPM',
      classification: 'System error',
    },
    [1 << 9]: {
      description: 'Low insulation impedance',
      source: 'DSPS',
      classification: 'Safety error',
    },
    [1 << 10]: {
      description: 'Grounding error',
      source: 'DSPS',
      classification: 'Safety error',
    },
    [1 << 11]: {
      description: 'Wrong input mode setting',
      source: 'DSPS',
      classification: 'Configuration error',
    },
    [1 << 12]: {
      description: 'CT error',
      source: 'DSPM&S',
      classification: 'Hardware error',
    },
    [1 << 13]: {
      description: 'Input reversal error',
      source: 'DSPS',
      classification: 'Configuration error',
    },
    [1 << 14]: {
      description: 'Parallel error',
      source: 'DSPM',
      classification: 'Configuration error',
    },
    [1 << 15]: {
      description: 'Serial number error',
      source: 'DSPM&S',
      classification: 'System error',
    }
  },
  4: {
    [1 << 0]: {
      description: 'Battery temperature protection',
      source: 'DSPM&S',
      classification: 'Temperature',
    },
    [1 << 1]: {
      description: 'Radiator 1 temperature protection',
      source: 'DSPM&S',
      classification: 'Temperature',
    },
    [1 << 2]: {
      description: 'Radiator 2 temperature protection',
      source: 'DSPM&S',
      classification: 'Temperature',
    },
    [1 << 3]: {
      description: 'Radiator 3 temperature protection',
      source: 'DSPM&S',
      classification: 'Temperature',
    },
    [1 << 4]: {
      description: 'Radiator 4 temperature protection',
      source: 'DSPM&S',
      classification: 'Temperature',
    },
    [1 << 5]: {
      description: 'Radiator 5 temperature protection',
      source: 'DSPM&S',
      classification: 'Temperature',
    },
    [1 << 6]: {
      description: 'Radiator 6 temperature protection',
      source: 'DSPM&S',
      classification: 'Temperature',
    },
    [1 << 7]: {
      description: 'NTC error',
      source: 'DSPM&S',
      classification: 'Temperature',
    },
    [1 << 8]: {
      description: 'Ambient temperature 1 protection',
      level: 2,
      source: 'DSPM&S',
      classification: 'Temperature',
    },
    [1 << 9]: {
      description: 'Ambient temperature 2 protection',
      level: 2,
      source: 'DSPM&S',
      classification: 'Temperature',
    },
    [1 << 10]: {
      description: 'Module 1 temperature protection',
      source: 'DSPM&S',
      classification: 'Temperature',
    },
    [1 << 11]: {
      description: 'Module 2 temperature protection',
      source: 'DSPM&S',
      classification: 'Temperature',
    },
    [1 << 12]: {
      description: 'Module 3 temperature protection',
      source: 'DSPM&S',
      classification: 'Temperature',
    },
    [1 << 13]: {
      description: 'Module temperature difference too large',
      source: 'DSPM&S',
      classification: 'Temperature',
    },
    [1 << 14]: {
      description: 'N/A',
      source: '',
      classification: '',
    },
    [1 << 15]: {
      description: 'N/A',
      source: '',
      classification: '',
    },
  },
  5: {
    [1 << 0]: {
      description: 'Bus-bar valid value unbalanced',
      level: 2,
      source: 'DSPM',
      classification: 'Over and under voltage',
    },
    [1 << 1]: {
      description: 'Bus-bar instantaneous value unbalance',
      level: 2,
      source: 'DSPM',
      classification: 'Over and under voltage',
    },
    [1 << 2]: {
      description: 'Bus-bar under-voltage during grid connection',
      level: 2,
      source: 'DSPM',
      classification: 'Over and under voltage',
    },
    [1 << 3]: {
      description: 'Bus-bar low voltage',
      source: 'DSPM',
      classification: 'Over and under voltage',
    },
    [1 << 4]: {
      description: 'PV over-voltage',
      level: 2,
      source: 'DSPS',
      classification: 'Over and under voltage',
    },
    [1 << 5]: {
      description: 'Battery over-voltage',
      level: 2,
      source: 'DSPS',
      classification: 'Over and under voltage',
    },
    [1 << 6]: {
      description: 'LLC-Bus over-voltage protection',
      source: 'DSPS',
      classification: 'Over and under voltage',
    },
    [1 << 7]: {
      description: 'Bus-bar Rms software over-voltage',
      level: 2,
      source: 'DSPM',
      classification: 'Over and under voltage',
    },
    [1 << 8]: {
      description: 'Bus-bar transient software over-voltage',
      level: 2,
      source: 'DSPM',
      classification: 'Over and under voltage',
    },
    [1 << 9]: {
      description: 'Fly-span capacitor over-voltage protection',
      source: 'DSPM&S',
      classification: 'Over and under voltage',
    },
    [1 << 10]: {
      description: 'Fly-span capacitor under-voltage protection',
      source: 'DSPM&S',
      classification: 'Over and under voltage',
    },
    [1 << 11]: {
      description: 'PV under-voltage',
      source: 'DSPM&S',
      classification: 'Over and under voltage',
    },
    [1 << 12]: {
      description: 'N/A',
      source: '',
      classification: '',
    },
    [1 << 13]: {
      description: 'N/A',
      source: '',
      classification: '',
    },
    [1 << 14]: {
      description: 'N/A',
      source: '',
      classification: '',
    },
    [1 << 15]: {
      description: 'N/A',
      source: '',
      classification: '',
    },
  },
  6: {
    [1 << 0]: {
      description: '081 Battery Overcurrent Software Protection',
      level: 2,
      source: 'DSPS',
      classification: 'Current',
    },
    [1 << 1]: {
      description: '082 DCI Overcurrent Protection',
      level: 2,
      source: 'DSPM',
      classification: 'Current',
    },
    [1 << 2]: {
      description: '083 Output Transient Current Protection',
      level: 2,
      source: 'DSPM',
      classification: 'Current',
    },
    [1 << 3]: {
      description: '084 BuckBoost Software Overcurrent',
      source: 'DSPS',
      classification: 'Current',
    },
    [1 << 4]: {
      description: '085 Inverter RMS Current Protection',
      level: 2,
      source: 'DSPM',
      classification: 'Current',
    },
    [1 << 5]: {
      description: '086 PV Transient Software Overcurrent',
      source: 'DSPS',
      classification: 'Current',
    },
    [1 << 6]: {
      description: '087 PV Parallel Uneven Current',
      source: 'DSPS',
      classification: 'Current',
    },
    [1 << 7]: {
      description: '088 Output Current Unbalance',
      source: 'DSPM',
      classification: 'Current',
    },
    [1 << 8]: {
      description: '089 PV Software Overcurrent Protection',
      source: 'DSPM&S',
      classification: 'Current',
    },
    [1 << 9]: {
      description: '090 Balanced Circuit Overcurrent Protection',
      source: 'DSPM&S',
      classification: 'Current',
    },
    [1 << 10]: {
      description: '091 Resonance Protection',
      source: 'DSPM',
      classification: 'Current',
    },
    [1 << 11]: {
      description: '092 Software Wave-by-Wave Current Limit Protection',
      source: 'DSPM',
      classification: 'Current',
    },
    [1 << 12]: {
      description: '093 PV Branch Software Overcurrent 1 (Enabled by Default)',
      source: 'DSPM',
      classification: 'Current',
    },
    [1 << 13]: {
      description: '094 Primary DC Charge and Discharge Overcurrent Protection',
      source: 'DSPM&S',
      classification: 'Current',
    },
    [1 << 14]: {
      description: '095 Software BUS Overcurrent Protection',
      source: 'DSPM&S',
      classification: 'Current',
    },
    [1 << 15]: {
      description: '096 N/A',
      source: '',
      classification: '',
    },
  },
  7: {
    [1 << 0]: {
      description: '097 LLC Bus-Bar Hardware Overvoltage',
      source: 'DSPS',
      classification: 'Hardware Signal',
    },
    [1 << 1]: {
      description: '098 Inverter Bus Hardware Overvoltage',
      level: 2,
      source: 'DSPM',
      classification: 'Hardware Signal',
    },
    [1 << 2]: {
      description: '099 BuckBoost Hardware Overcurrent',
      source: 'DSPS',
      classification: 'Hardware Signal',
    },
    [1 << 3]: {
      description: '100 Battery Hardware Overcurrent',
      source: 'DSPS',
      classification: 'Hardware Signal',
    },
    [1 << 4]: {
      description: '101 Primary DC Hardware GaN Tube Error',
      source: 'DSPS',
      classification: 'Hardware Signal',
    },
    [1 << 5]: {
      description: '102 PV Hardware Overcurrent',
      level: 2,
      source: 'DSPS',
      classification: 'Hardware Signal',
    },
    [1 << 6]: {
      description: '103 AC Output Hardware Overcurrent',
      level: 2,
      source: 'DSPM',
      classification: 'Hardware Signal',
    },
    [1 << 7]: {
      description: '104 Hardware Differential Overcurrent',
      source: 'DSPM&S',
      classification: 'Hardware Signal',
    },
    [1 << 8]: {
      description: '105 Meter Communication Error',
      source: 'DSPM&S',
      classification: 'System',
    },
    [1 << 9]: {
      description: '106 Serial Number Model Error',
      source: '',
      classification: 'System',
    },
    [1 << 10]: {
      description: '107 Hardware Version Mismatch',
      source: '',
      classification: 'System',
    },
    [1 << 11]: {
      description: '108 Generator Startup Failure',
      source: 'DSPM',
      classification: 'System',
    },
    [1 << 12]: {
      description: '109 Generator Overload Protection',
      source: 'DSPM',
      classification: 'System',
    },
    [1 << 13]: {
      description: '110 Overload Protection 1',
      level: 2,
      source: 'DSPM',
      classification: 'Overload',
    },
    [1 << 14]: {
      description: '111 Overload Protection 2',
      level: 2,
      source: 'DSPM',
      classification: 'Overload',
    },
    [1 << 15]: {
      description: '112 Overload Protection 3',
      level: 2,
      source: 'DSPM',
      classification: 'Overload',
    },
  },
  8: {
    [1 << 0]: {
      description: '113 Overtemperature Load-Down',
      level: 2,
      source: 'DSPM',
      classification: 'Load Reduction',
      warning: 'This fault is only used to generate an alarm and will not directly cause the system to enter a fault state.',
    },
    [1 << 1]: {
      description: '114 Frequency Load-Down',
      level: 2,
      source: 'DSPM',
      classification: 'Load Reduction',
    },
    [1 << 2]: {
      description: '115 Frequency Loading',
      source: 'DSPM',
      classification: 'Load Reduction',
    },
    [1 << 3]: {
      description: '116 Voltage Load-Down',
      source: 'DSPM',
      classification: 'Load Reduction',
    },
    [1 << 4]: {
      description: '117 Voltage Loading',
      source: 'DSPM',
      classification: 'Load Reduction',
    },
    [1 << 5]: {
      description: '118 Low Temperature Load-Down',
      source: 'DSPM',
      classification: 'Load Reduction',
    },
    [1 << 8]: {
      description: '121 Lightning Protection Fault (DC)',
      source: '',
      classification: 'Shutdown',
    },
    [1 << 9]: {
      description: '122 Lightning Protection Fault (AC)',
      source: '',
      classification: 'Shutdown',
    },
    [1 << 10]: {
      description: '123 Output Short Circuit Error',
      source: '',
      classification: 'Shutdown',
    },
    [1 << 11]: {
      description: '124 Low Battery Power',
      source: '',
      classification: 'Shutdown',
    },
    [1 << 12]: {
      description: '125 Battery Prohibit Discharge Alarm',
      source: '',
      classification: 'Shutdown',
    },
    [1 << 15]: {
      description: '128 Battery Input Reverse Protection',
      source: '',
      classification: 'Shutdown',
    },
  },
  9: {
    [1 << 0]: {
      description: '129 AC Hardware Overcurrent Fault',
      source: 'DSPM',
      classification: 'Permanent',
    },
    [1 << 1]: {
      description: '130 Bus Overvoltage Fault',
      level: 2,
      source: 'DSPM',
      classification: 'Permanent',
    },
    [1 << 2]: {
      description: '131 Bus Hardware Overvoltage Fault',
      source: 'DSPM',
      classification: 'Permanent',
    },
    [1 << 3]: {
      description: '132 PV Uneven Flow Fault',
      source: 'DSPS',
      classification: 'Permanent',
    },
    [1 << 4]: {
      description: '133 EPS Battery Overcurrent Fault',
      source: 'DSPM',
      classification: 'Permanent',
    },
    [1 << 5]: {
      description: '134 Output Transient Overcurrent Fault',
      level: 2,
      source: 'DSPM',
      classification: 'Permanent',
    },
    [1 << 6]: {
      description: '135 AC Current Unbalance Fault',
      source: 'DSPM',
      classification: 'Permanent',
    },
    [1 << 7]: {
      description: '136 Inverter Soft Start Failure Fault',
      source: 'DSPM',
      classification: 'Permanent',
    },
    [1 << 8]: {
      description: '137 Input Mode Setting Fault',
      source: 'DSPS',
      classification: 'Permanent',
    },
    [1 << 9]: {
      description: '138 Input Overcurrent Fault',
      level: 2,
      source: 'DSPS',
      classification: 'Permanent',
    },
    [1 << 10]: {
      description: '139 Input Hardware Overcurrent Fault',
      source: 'DSPS',
      classification: 'Permanent',
    },
    [1 << 11]: {
      description: '140 Relay Permanent Failure',
      source: 'DSPM',
      classification: 'Permanent',
    },
    [1 << 12]: {
      description: '141 Bus Unbalance Fault',
      level: 2,
      source: 'DSPM',
      classification: 'Permanent',
    },
    [1 << 13]: {
      description: '142 Lightning Protection Fault (DC)',
      source: 'DSPS',
      classification: 'Permanent',
    },
    [1 << 14]: {
      description: '143 Lightning Protection Fault (AC)',
      source: 'DSPM',
      classification: 'Permanent',
    },
    [1 << 15]: {
      description: '144 Grid Relay Fault',
      source: '',
      classification: 'Permanent',
    },
  },
  10: {
    [1 << 0]: {
      description: '145 USB Fault',
      level: 2,
      source: 'ARM',
      classification: 'Communication Board',
    },
    [1 << 1]: {
      description: '146 WIFI Fault',
      source: 'ARM',
      classification: 'Communication Board',
    },
    [1 << 2]: {
      description: '147 Bluetooth Fault',
      level: 2,
      source: 'ARM',
      classification: 'Communication Board',
    },
    [1 << 3]: {
      description: '148 RTC Clock Fault',
      source: 'ARM',
      classification: 'Communication Board',
    },
    [1 << 4]: {
      description: '149 Communication Board EEPROM Error',
      source: 'ARM',
      classification: 'Communication Board',
    },
    [1 << 5]: {
      description: '150 Communication Board FLASH Error',
      source: 'ARM',
      classification: 'Communication Board',
    },
    [1 << 6]: {
      description: '151 Battery Partially Disconnected',
      source: 'ARM',
      classification: 'Communication Board',
    },
    [1 << 7]: {
      description: '152 Safety Version Error',
      source: 'ARM',
      classification: 'Communication Board',
    },
    [1 << 8]: {
      description: '153 SCI Error (DC)',
      level: 2,
      source: 'ARM',
      classification: 'Communication Board',
    },
    [1 << 9]: {
      description: '154 SCI Error (AC)',
      level: 2,
      source: 'ARM',
      classification: 'Communication Board',
    },
    [1 << 10]: {
      description: '155 SCI Error (Fuse)',
      source: 'ARM',
      classification: 'Communication Board',
    },
    [1 << 11]: {
      description: '156 Software Version Inconsistency',
      level: 2,
      source: 'ARM',
      classification: 'Communication Board',
    },
    [1 << 12]: {
      description: '157 Lithium Battery 1 Communication Failure',
      level: 2,
      source: 'ARM',
      classification: 'Communication Board',
    },
    [1 << 13]: {
      description: '158 Lithium Battery 2 Communication Failure',
      level: 2,
      source: 'ARM',
      classification: 'Communication Board',
    },
    [1 << 14]: {
      description: '159 Lithium Battery 3 Communication Failure',
      source: 'ARM',
      classification: 'Communication Board',
    },
    [1 << 15]: {
      description: '160 Lithium Battery 4 Communication Failure',
      source: 'ARM',
      classification: 'Communication Board',
    },
  },
  11: {
    [1 << 0]: {
      description: '161 Forced Shutdown',
      source: 'ARM',
      classification: 'Load Reduction',
    },
    [1 << 1]: {
      description: '162 Remote Shutdown',
      level: 2,
      source: 'ARM',
      classification: 'Load Reduction',
    },
    [1 << 2]: {
      description: '163 DRMS0 Shutdown',
      level: 2,
      source: 'ARM',
      classification: 'Load Reduction',
    },
    [1 << 3]: {
      description: '164 Power Station Communication Failure Shutdown',
      source: 'ARM',
      classification: 'Load Reduction',
    },
    [1 << 7]: {
      description: '168 AFCI Force Shutdown',
      source: 'ARM',
      classification: 'Load Reduction',
    },
    [1 << 8]: {
      description: '169 Fan 1 Fault',
      level: 2,
      source: 'ARM',
      classification: 'External Components',
    },
    [1 << 9]: {
      description: '170 Fan 2 Fault',
      level: 2,
      source: 'ARM',
      classification: 'External Components',
    },
    [1 << 10]: {
      description: '171 Fan 3 Fault',
      level: 2,
      source: 'ARM',
      classification: 'External Components',
    },
    [1 << 11]: {
      description: '172 Fan 4 Fault',
      level: 2,
      source: 'ARM',
      classification: 'External Components',
    },
    [1 << 12]: {
      description: '173 Fan 5 Fault',
      level: 2,
      source: 'ARM',
      classification: 'External Components',
    },
    [1 << 13]: {
      description: '174 Fan 6 Fault',
      level: 2,
      source: 'ARM',
      classification: 'External Components',
    },
    [1 << 14]: {
      description: '175 Fan 7 Fault',
      level: 2,
      source: 'ARM',
      classification: 'External Components',
    },
    [1 << 15]: {
      description: '176 Heating Film Fault',
      source: 'ARM',
      classification: 'External Components',
    },
  },
  12: {
    [1 << 0]: {
      description: '177 BMS Overvoltage Protection',
      level: 2,
      source: 'BMS',
      classification: 'BMS',
    },
    [1 << 1]: {
      description: '178 BMS Undervoltage Protection',
      level: 2,
      source: 'BMS',
      classification: 'BMS',
    },
    [1 << 2]: {
      description: 'BMS high temperature alarm',
      source: 'BMS',
      classification: 'BMS',
    },
    [1 << 3]: {
      description: '180 BMS Low Temperature Protection',
      level: 2,
      source: 'BMS',
      classification: 'BMS',
    },
    [1 << 4]: {
      description: 'BMS charge/discharge overload alarm',
      source: 'BMS',
      classification: 'BMS',
    },
    [1 << 5]: {
      description: 'BMS short circuit alarm',
      source: 'BMS',
      classification: 'BMS',
    },
    [1 << 6]: {
      description: 'BMS version inconsistency',
      source: 'ARM',
      classification: 'BMS',
    },
    [1 << 7]: {
      description: 'BMS CAN version inconsistency',
      source: 'ARM',
      classification: 'BMS',
    },
    [1 << 8]: {
      description: 'BMS CAN version is too low',
      source: 'ARM',
      classification: 'BMS',
    },
    [1 << 12]: {
      description: 'Arc device communication failure',
      source: 'ARM',
      classification: 'BMS',
    },
    [1 << 13]: {
      description: 'DC arc alarm fault',
      source: 'ARM',
      classification: 'BMS',
    },
    [1 << 14]: {
      description: 'PID repair failed',
      source: 'ARM',
      classification: 'BMS',
    },
    [1 << 15]: {
      description: 'PLC module heartbeat loss',
      source: 'ARM',
      classification: 'BMS',
    },
  },
  13: {
    [1 << 0]: {
      description: 'String fuse open circuit alarm 1-1',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 1]: {
      description: 'String fuse open circuit alarm 1-2',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 2]: {
      description: 'String fuse open circuit alarm 2-1',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 3]: {
      description: 'String fuse open circuit alarm 2-2',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 4]: {
      description: 'String fuse open circuit alarm 3-1',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 5]: {
      description: 'String fuse open circuit alarm 3-2',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 6]: {
      description: 'String fuse open circuit alarm 4-1',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 7]: {
      description: 'String fuse open circuit alarm 4-2',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 8]: {
      description: 'String fuse open circuit alarm 5-1',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 9]: {
      description: 'String fuse open circuit alarm 5-2',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 10]: {
      description: 'String fuse open circuit alarm 6-1',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 11]: {
      description: 'String fuse open circuit alarm 6-2',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 12]: {
      description: 'String fuse open circuit alarm 7-1',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 13]: {
      description: 'String fuse open circuit alarm 7-2',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 14]: {
      description: 'String fuse open circuit alarm 8-1',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 15]: {
      description: 'String fuse open circuit alarm 8-2',
      source: 'FUSE',
      classification: 'FUSE',
    },
  },
  14: {
    [1 << 0]: {
      description: 'String fuse open circuit alarm 9-1',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 1]: {
      description: 'String fuse open circuit alarm 9-2',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 2]: {
      description: 'String fuse open circuit alarm 10-1',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 3]: {
      description: 'String fuse open circuit alarm 10-2',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 4]: {
      description: 'String fuse open circuit alarm 11-1',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 5]: {
      description: 'String fuse open circuit alarm 11-2',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 6]: {
      description: 'String fuse open circuit alarm 12-1',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 7]: {
      description: 'String fuse open circuit alarm 12-2',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 8]: {
      description: 'String fuse open circuit alarm 13-1',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 9]: {
      description: 'String fuse open circuit alarm 13-2',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 10]: {
      description: 'String fuse open circuit alarm 14-1',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 11]: {
      description: 'String fuse open circuit alarm 14-2',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 12]: {
      description: 'String fuse open circuit alarm 15-1',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 13]: {
      description: 'String fuse open circuit alarm 15-2',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 14]: {
      description: 'String fuse open circuit alarm 16-1',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 15]: {
      description: 'String fuse open circuit alarm 16-2',
      source: 'FUSE',
      classification: 'FUSE',
    },
  },
  15: {
    [1 << 0]: {
      description: 'Input insurance open circuit 0',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 1]: {
      description: 'Input insurance open circuit 1',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 2]: {
      description: 'Input insurance open circuit 2',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 3]: {
      description: 'Input insurance open circuit 3',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 4]: {
      description: 'Input insurance open circuit 4',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 5]: {
      description: 'Input insurance open circuit 5',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 6]: {
      description: 'Input insurance open circuit 6',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 7]: {
      description: 'Input insurance open circuit 7',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 8]: {
      description: 'Input insurance open circuit 8',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 9]: {
      description: 'Input insurance open circuit 9',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 10]: {
      description: 'Input insurance open circuit 10',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 11]: {
      description: 'Input insurance open circuit 11',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 12]: {
      description: 'Input insurance open circuit 12',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 13]: {
      description: 'Input insurance open circuit 13',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 14]: {
      description: 'Input insurance open circuit 14',
      source: 'FUSE',
      classification: 'FUSE',
    },
    [1 << 15]: {
      description: 'Input insurance open circuit 15',
      source: 'FUSE',
      classification: 'FUSE',
    },
  },
  16: {
    [1 << 0]: { description: '241 Combiner Overvoltage Group 1', source: 'Combiner', classification: 'Combiner' },
    [1 << 1]: { description: '242 Combiner Overvoltage Group 2', source: 'Combiner', classification: 'Combiner' },
    [1 << 2]: { description: '243 Combiner Overvoltage Group 3', source: 'Combiner', classification: 'Combiner' },
    [1 << 3]: { description: '244 Combiner Overvoltage Group 4', source: 'Combiner', classification: 'Combiner' },
    [1 << 4]: { description: '245 Combiner Overvoltage Group 5', source: 'Combiner', classification: 'Combiner' },
    [1 << 5]: { description: '246 Combiner Overvoltage Group 6', source: 'Combiner', classification: 'Combiner' },
    [1 << 6]: { description: '247 Combiner Overvoltage Group 7', source: 'Combiner', classification: 'Combiner' },
    [1 << 7]: { description: '248 Combiner Overvoltage Group 8', source: 'Combiner', classification: 'Combiner' },
    [1 << 8]: { description: '249 Combiner Overvoltage Group 9', source: 'Combiner', classification: 'Combiner' },
    [1 << 9]: { description: '250 Combiner Overvoltage Group 10', source: 'Combiner', classification: 'Combiner' },
    [1 << 10]: { description: '251 Combiner Overvoltage Group 11', source: 'Combiner', classification: 'Combiner' },
    [1 << 11]: { description: '252 Combiner Overvoltage Group 12', source: 'Combiner', classification: 'Combiner' },
    [1 << 12]: { description: '253 Combiner Overvoltage Group 13', source: 'Combiner', classification: 'Combiner' },
    [1 << 13]: { description: '254 Combiner Overvoltage Group 14', source: 'Combiner', classification: 'Combiner' },
    [1 << 14]: { description: '255 Combiner Overvoltage Group 15', source: 'Combiner', classification: 'Combiner' },
    [1 << 15]: { description: '256 Combiner Overvoltage Group 16', source: 'Combiner', classification: 'Combiner' },
  },
  17: {
    [1 << 0]: { description: '257 Combiner Undervoltage Group 1', source: 'Combiner', classification: 'Combiner' },
    [1 << 1]: { description: '258 Combiner Undervoltage Group 2', source: 'Combiner', classification: 'Combiner' },
    [1 << 2]: { description: '259 Combiner Undervoltage Group 3', source: 'Combiner', classification: 'Combiner' },
    [1 << 3]: { description: '260 Combiner Undervoltage Group 4', source: 'Combiner', classification: 'Combiner' },
    [1 << 4]: { description: '261 Combiner Undervoltage Group 5', source: 'Combiner', classification: 'Combiner' },
    [1 << 5]: { description: '262 Combiner Undervoltage Group 6', source: 'Combiner', classification: 'Combiner' },
    [1 << 6]: { description: '263 Combiner Undervoltage Group 7', source: 'Combiner', classification: 'Combiner' },
    [1 << 7]: { description: '264 Combiner Undervoltage Group 8', source: 'Combiner', classification: 'Combiner' },
    [1 << 8]: { description: '265 Combiner Undervoltage Group 9', source: 'Combiner', classification: 'Combiner' },
    [1 << 9]: { description: '266 Combiner Undervoltage Group 10', source: 'Combiner', classification: 'Combiner' },
    [1 << 10]: { description: '267 Combiner Undervoltage Group 11', source: 'Combiner', classification: 'Combiner' },
    [1 << 11]: { description: '268 Combiner Undervoltage Group 12', source: 'Combiner', classification: 'Combiner' },
    [1 << 12]: { description: '269 Combiner Undervoltage Group 13', source: 'Combiner', classification: 'Combiner' },
    [1 << 13]: { description: '270 Combiner Undervoltage Group 14', source: 'Combiner', classification: 'Combiner' },
    [1 << 14]: { description: '271 Combiner Undervoltage Group 15', source: 'Combiner', classification: 'Combiner' },
    [1 << 15]: { description: '272 Combiner Undervoltage Group 16', source: 'Combiner', classification: 'Combiner' },
  },
  18: {
    [1 << 0]: { description: '273 Combiner Overcurrent 1', source: 'Combiner', classification: 'Combiner' },
    [1 << 1]: { description: '274 Combiner Overcurrent 2', source: 'Combiner', classification: 'Combiner' },
    [1 << 2]: { description: '275 Combiner Overcurrent 3', source: 'Combiner', classification: 'Combiner' },
    [1 << 3]: { description: '276 Combiner Overcurrent 4', source: 'Combiner', classification: 'Combiner' },
    [1 << 4]: { description: '277 Combiner Overcurrent 5', source: 'Combiner', classification: 'Combiner' },
    [1 << 5]: { description: '278 Combiner Overcurrent 6', source: 'Combiner', classification: 'Combiner' },
    [1 << 6]: { description: '279 Combiner Overcurrent 7', source: 'Combiner', classification: 'Combiner' },
    [1 << 7]: { description: '280 Combiner Overcurrent 8', source: 'Combiner', classification: 'Combiner' },
    [1 << 8]: { description: '281 Combiner Overcurrent 9', source: 'Combiner', classification: 'Combiner' },
    [1 << 9]: { description: '282 Combiner Overcurrent 10', source: 'Combiner', classification: 'Combiner' },
    [1 << 10]: { description: '283 Combiner Overcurrent 11', source: 'Combiner', classification: 'Combiner' },
    [1 << 11]: { description: '284 Combiner Overcurrent 12', source: 'Combiner', classification: 'Combiner' },
    [1 << 12]: { description: '285 Combiner Overcurrent 13', source: 'Combiner', classification: 'Combiner' },
    [1 << 13]: { description: '286 Combiner Overcurrent 14', source: 'Combiner', classification: 'Combiner' },
    [1 << 14]: { description: '287 Combiner Overcurrent 15', source: 'Combiner', classification: 'Combiner' },
    [1 << 15]: { description: '288 Combiner Overcurrent 16', source: 'Combiner', classification: 'Combiner' },
  },
  19: {
    [1 << 0]: { description: '289 Combiner Overcurrent 17', source: 'Combiner', classification: 'Combiner' },
    [1 << 1]: { description: '290 Combiner Overcurrent 18', source: 'Combiner', classification: 'Combiner' },
    [1 << 2]: { description: '291 Combiner Overcurrent 19', source: 'Combiner', classification: 'Combiner' },
    [1 << 3]: { description: '292 Combiner Overcurrent 20', source: 'Combiner', classification: 'Combiner' },
    [1 << 4]: { description: '293 Combiner Overcurrent 21', source: 'Combiner', classification: 'Combiner' },
    [1 << 5]: { description: '294 Combiner Overcurrent 22', source: 'Combiner', classification: 'Combiner' },
    [1 << 6]: { description: '295 Combiner Overcurrent 23', source: 'Combiner', classification: 'Combiner' },
    [1 << 7]: { description: '296 Combiner Overcurrent 24', source: 'Combiner', classification: 'Combiner' },
    [1 << 8]: { description: '297 Combiner Overcurrent 25', source: 'Combiner', classification: 'Combiner' },
    [1 << 9]: { description: '298 Combiner Overcurrent 26', source: 'Combiner', classification: 'Combiner' },
    [1 << 10]: { description: '299 Combiner Overcurrent 27', source: 'Combiner', classification: 'Combiner' },
    [1 << 11]: { description: '300 Combiner Overcurrent 28', source: 'Combiner', classification: 'Combiner' },
    [1 << 12]: { description: '301 Combiner Overcurrent 29', source: 'Combiner', classification: 'Combiner' },
    [1 << 13]: { description: '302 Combiner Overcurrent 30', source: 'Combiner', classification: 'Combiner' },
    [1 << 14]: { description: '303 Combiner Overcurrent 31', source: 'Combiner', classification: 'Combiner' },
    [1 << 15]: { description: '304 Combiner Overcurrent 32', source: 'Combiner', classification: 'Combiner' },
  },
  20: {
    [1 << 0]: {
      description: 'Control unit over temperature warning',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 1]: {
      description: 'Control unit over temperature protection',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 2]: {
      description: 'Control unit low temperature warning',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 3]: {
      description: 'Temperature sensor fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 4]: {
      description: 'Abnormal DC port temperature (including temperature and NTC abnormalities)',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 5]: {
      description: 'Abnormal AC port temperature (including temperature and NTC abnormalities)',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 8]: {
      description: 'Module 4 temperature protection',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 9]: {
      description: 'Module 5 temperature protection',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 10]: {
      description: 'Module 6 temperature protection',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
  },
  21: {
    [1 << 0]: {
      description: 'Grid phase sequence error',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 1]: {
      description: 'Phase line to ground failure',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 2]: {
      description: 'Anti short circuit protection',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 3]: {
      description: 'Anti shot circuit device fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 4]: {
      description: 'DC relay fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 5]: {
      description: 'Anti short circuit temperature error',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 6]: {
      description: 'Module temperature low protection',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 7]: {
      description: 'AC start timeout',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 8]: {
      description: 'Over modulation',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 9]: {
      description: 'Device ID mismatch',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 10]: {
      description: 'Internal communication fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 11]: {
      description: 'Carrier synchronization signal fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 12]: {
      description: 'Bus short circuit protection',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 13]: {
      description: 'Boost short circuit fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 14]: {
      description: 'Pv+ground short circuit fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
  },
  22: {
    [1 << 0]: {
      description: '337 Combiner Reflux Fault 1',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 1]: {
      description: '338 Combiner Reflux Fault 2',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 2]: {
      description: '339 Combiner Reflux Fault 3',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 3]: {
      description: '340 Combiner Reflux Fault 4',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 4]: {
      description: '341 Combiner Reflux Fault 5',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 5]: {
      description: '342 Combiner Reflux Fault 6',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 6]: {
      description: '343 Combiner Reflux Fault 7',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 7]: {
      description: '344 Combiner Reflux Fault 8',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 8]: {
      description: '345 Combiner Reflux Fault 9',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 9]: {
      description: '346 Combiner Reflux Fault 10',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 10]: {
      description: '347 Combiner Reflux Fault 11',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 11]: {
      description: '348 Combiner Reflux Fault 12',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 12]: {
      description: '349 Combiner Reflux Fault 13',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 13]: {
      description: '350 Combiner Reflux Fault 14',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 14]: {
      description: '351 Combiner Reflux Fault 15',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 15]: {
      description: '352 Combiner Reflux Fault 16',
      source: 'Combiner',
      classification: 'Combiner',
    },
  },
  23: {
    [1 << 0]: {
      description: '353 Combiner Reflux Fault 17',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 1]: {
      description: '354 Combiner Reflux Fault 18',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 2]: {
      description: '355 Combiner Reflux Fault 19',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 3]: {
      description: '356 Combiner Reflux Fault 20',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 4]: {
      description: '357 Combiner Reflux Fault 21',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 5]: {
      description: '358 Combiner Reflux Fault 22',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 6]: {
      description: '359 Combiner Reflux Fault 23',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 7]: {
      description: '360 Combiner Reflux Fault 24',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 8]: {
      description: '361 Combiner Reflux Fault 25',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 9]: {
      description: '362 Combiner Reflux Fault 26',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 10]: {
      description: '363 Combiner Reflux Fault 27',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 11]: {
      description: '364 Combiner Reflux Fault 28',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 12]: {
      description: '365 Combiner Reflux Fault 29',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 13]: {
      description: '366 Combiner Reflux Fault 30',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 14]: {
      description: '367 Combiner Reflux Fault 31',
      source: 'Combiner',
      classification: 'Combiner',
    },
    [1 << 15]: {
      description: '368 Combiner Reflux Fault 32',
      source: 'Combiner',
      classification: 'Combiner',
    },
  },
  24: {
    [1 << 8]: {
      description: 'Inverter hardware MOS tube fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 9]: {
      description: 'EPS hardware output over current protection',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 10]: {
      description: 'AFCI self-checking error',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 11]: {
      description: 'Load short circuit protection',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 12]: {
      description: 'DC switch 1 trip',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 13]: {
      description: 'DC switch 2 trip',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 14]: {
      description: 'DC switch 3 trip',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 15]: {
      description: 'DC switch 4 trip',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
  },
  25: {
    [1 << 0]: {
      description: 'Hardware AD sampling bias error',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 1]: {
      description: 'Fan 8 fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
  },
  26: {
    [1 << 0]: {
      description: 'Arc failure 0',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 1]: {
      description: 'Arc failure 1',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 2]: {
      description: 'Arc failure 2',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 3]: {
      description: 'Arc failure 3',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 4]: {
      description: 'Arc failure 4',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 5]: {
      description: 'Arc failure 5',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 6]: {
      description: 'Arc failure 6',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 7]: {
      description: 'Arc failure 7',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 8]: {
      description: 'Arc failure 8',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 9]: {
      description: 'Arc failure 9',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 10]: {
      description: 'Arc failure 10',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 11]: {
      description: 'Arc failure 11',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 12]: {
      description: 'Arc failure 12',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 13]: {
      description: 'Arc failure 13',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 14]: {
      description: 'Arc failure 14',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 15]: {
      description: 'Arc failure 15',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
  },
  27: {
    [1 << 0]: {
      description: 'Arc failure 16',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 1]: {
      description: 'Arc failure 17',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 2]: {
      description: 'Arc failure 18',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 3]: {
      description: 'Arc failure 19',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 4]: {
      description: 'Arc failure 20',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 5]: {
      description: 'Arc failure 21',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 6]: {
      description: 'Arc failure 22',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 7]: {
      description: 'Arc failure 23',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 8]: {
      description: 'Arc failure 24',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 9]: {
      description: 'Arc failure 25',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 10]: {
      description: 'Arc failure 26',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 11]: {
      description: 'Arc failure 27',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 12]: {
      description: 'Arc failure 28',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 13]: {
      description: 'Arc failure 29',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 14]: {
      description: 'Arc failure 30',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 15]: {
      description: 'Arc failure 31',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
  },
  28: {
    [1 << 0]: {
      description: 'AFCI 1 communication fault',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 1]: {
      description: 'AFCI 2 communication fault',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 8]: {
      description: 'Modify over voltage protection',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 9]: {
      description: 'ARM_DSP protocol version inconsistent',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 10]: {
      description: 'ARM_AFCI protocol version inconsistent',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
    [1 << 11]: {
      description: 'ARM_DCDC protocol version inconsistent',
      source: 'COMBINER',
      classification: 'COMBINER',
    },
  },
  29: {
    [1 << 0]: {
      description: 'The ground zero voltage is too high',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 1]: {
      description: 'PV branch software over current 2(disabled by default)',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 2]: {
      description: 'N-line open circuit fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 3]: {
      description: 'Grid frequency change protection',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 4]: {
      description: 'Phase-loss failure',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 5]: {
      description: 'PV branch software current regurgitation',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 6]: {
      description: 'Inverter voltage sampling error',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 7]: {
      description: 'Inverter EPS sampling failure fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 8]: {
      description: 'Bus voltage consistency error',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 9]: {
      description: 'Bus current sampling error',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 10]: {
      description: 'Parallel off grid start synchronization fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 11]: {
      description: 'Primary hardware over current protection',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 12]: {
      description: 'Off-grid prohibited discharge failure',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 13]: {
      description: 'Live wire and ground wire short circuit fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 14]: {
      description: 'Permanent fault of live wire and ground wire short circuit',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
  },
  30: {
    [1 << 0]: {
      description: 'DCDC fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 1]: {
      description: 'BCU fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 2]: {
      description: 'BMU fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 3]: {
      description: 'PID fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 8]: {
      description: 'Discharge Mos fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 9]: {
      description: 'Charge Mos fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 10]: {
      description: 'Battery NTC fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 11]: {
      description: 'Cell fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 12]: {
      description: 'Cell voltage sampling fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
    [1 << 13]: {
      description: 'Storage fault',
      source: 'GENERIC',
      classification: 'GENERIC',
    },
  },
};

export const faultsPowerMagic: {
  [group: string]: {
    [id: number]: ErrorFeature;
  };
} = {
  "1": {
    1: { id: 1, description: "USB fault", source: "System", classification: "", level: 1 },
    2: { id: 2, description: "SD card fault", source: "System", classification: "", level: 1 },
    3: { id: 3, description: "RTC clock fault", source: "System", classification: "", level: 1 },
    4: { id: 4, description: "SPI communication fault", source: "System", classification: "", level: 1 },
    5: { id: 5, description: "SCI communication fault", source: "System", classification: "", level: 3 },
    6: { id: 6, description: "PCS communication fault", source: "System", classification: "", level: 3 },
    7: { id: 7, description: "Inconsistent protocol versions", source: "System", classification: "", level: 3 },
    8: { id: 8, description: "Inconsistency between file device parameters and actual", source: "System", classification: "", level: 3 },
    9: { id: 9, description: "Box transformer communication fault", source: "System", classification: "", level: 3 },
    10: { id: 10, description: "CMU1 communication fault", source: "System", classification: "", level: 1 },
    11: { id: 11, description: "CMU2 communication fault", source: "System", classification: "", level: 1 },
    12: { id: 12, description: "CMU3 communication fault", source: "System", classification: "", level: 1 },
    13: { id: 13, description: "CMU4 communication fault", source: "System", classification: "", level: 1 },
    14: { id: 14, description: "CMU5 communication fault", source: "System", classification: "", level: 1 },
    15: { id: 15, description: "CMU6 communication fault", source: "System", classification: "", level: 1 },
    16: { id: 16, description: "CSU parallel cabinet slave: local communication fault", source: "System", classification: "", level: 3 },
  },
  "101": {
    129: { id: 129, description: "USB fault", source: "System", classification: "", level: 1 },
    130: { id: 130, description: "SD card fault", source: "System", classification: "", level: 1 },
    131: { id: 131, description: "RTC clock fault", source: "System", classification: "", level: 1 },
    132: { id: 132, description: "SPI communication fault", source: "System", classification: "", level: 1 },
    133: { id: 133, description: "SCI communication fault", source: "System", classification: "", level: 3 },
    134: { id: 134, description: "BCU communication fault - BCU including battery expansion", source: "System", classification: "", level: 2 },
    135: { id: 135, description: "Inconsistent protocol versions", source: "System", classification: "", level: 1 },
    136: { id: 136, description: "Inconsistency between file device parameters and actual", source: "System", classification: "", level: 1 },
    137: { id: 137, description: "CMU-MCU1 APP upgrade failed", source: "System", classification: "", level: 1 },
    138: { id: 138, description: "CMU-MCU1 CORE upgrade failed", source: "System", classification: "", level: 1 },
    139: { id: 139, description: "CMU-MCU2 APP upgrade failed", source: "System", classification: "", level: 1 },
    140: { id: 140, description: "CMU-MCU2 CORE upgrade failed", source: "System", classification: "", level: 1 },
    141: { id: 141, description: "CSU communication fault", source: "System", classification: "", level: 3 },
  },
  "102": {
    145: { id: 145, description: "Unstable liquid cooling system", source: "System", classification: "", level: 3 },
    146: { id: 146, description: "PCS communication fault", source: "System", classification: "", level: 3 },
    147: { id: 147, description: "CSU system fault", source: "System", classification: "", level: 3 },
  },
  "131": {
    162: { id: 162, description: "SPD (Surge Protective Device) signal", source: "System", classification: "" },
    164: { id: 164, description: "EPO (emergency stop) (CMU DI)", source: "System", classification: "" },
    165: { id: 165, description: "External fault signal", source: "System", classification: "" },
    166: { id: 166, description: "CSU fault signal input", source: "System", classification: "" },
    168: { id: 168, description: "Battery cabinet water immersion DI1", source: "System", classification: "" },
    169: { id: 169, description: "Battery cabinet water immersion DI2", source: "System", classification: "" },
  },
  "132": {
    177: { id: 177, description: "Fire alarm signal (MCU2-DI)", source: "System", classification: "", level: 1 },
    178: { id: 178, description: "Fire alarm signal (MCU2-DI)", source: "System", classification: "", level: 2 },
    179: { id: 179, description: "Fire module fault signal (MCU2-DI)", source: "System", classification: "" },
    184: { id: 184, description: "Exhaust fan start (DO)", source: "System", classification: "" },
    185: { id: 185, description: "Fire start (DO)", source: "System", classification: "" },
    186: { id: 186, description: "Fire sound and light alarm (DO)", source: "System", classification: "" },
    187: { id: 187, description: "For CSU fault signals (DO)", source: "System", classification: "" },
    188: { id: 188, description: "External fault signal (DO)", source: "System", classification: "" },
    189: { id: 189, description: "Fault signal of high-voltage box (DO)", source: "System", classification: "" },
  },
  "133": {
    200: { id: 200, description: "Smoke Detector 1 (Battery cabinet 1)", source: "System", classification: "" },
    201: { id: 201, description: "Temperature sensor 1 (Battery cabinet 1)", source: "System", classification: "" },
    202: { id: 202, description: "Smoke Detector 2 (Battery cabinet 2)", source: "System", classification: "" },
    203: { id: 203, description: "Temperature sensor 2 (Battery cabinet 2)", source: "System", classification: "" },
    204: { id: 204, description: "Smoke Detector 3 (Battery cabinet 3)", source: "System", classification: "" },
    205: { id: 205, description: "Temperature sensor 3 (Battery cabinet 3)", source: "System", classification: "" },
    206: { id: 206, description: "Smoke Detector 4 (Battery cabinet 4)", source: "System", classification: "" },
    207: { id: 207, description: "Temperature sensor 4 (Battery cabinet 4)", source: "System", classification: "" },
  },
  "134": {
    208: { id: 208, description: "Smoke Detector 5 (Battery cabinet 5) Reserve", source: "System", classification: "" },
    209: { id: 209, description: "Temperature sensor 5 (Battery cabinet 5) Reserve", source: "System", classification: "" },
    210: { id: 210, description: "Smoke Detector 6 (Battery cabinet 6) Reserve", source: "System", classification: "" },
    211: { id: 211, description: "Temperature sensor 6 (Battery cabinet 6) Reserve", source: "System", classification: "" },
    212: { id: 212, description: "Fire pipe signal feedback", source: "System", classification: "" },
    216: { id: 216, description: "Fire extinguishing solenoid valve", source: "System", classification: "" },
    217: { id: 217, description: "Fire controller alarm", source: "System", classification: "", level: 1 },
    218: { id: 218, description: "Fire controller alarm", source: "System", classification: "", level: 2 },
    219: { id: 219, description: "Fire public fault signal", source: "System", classification: "" },
  },
  "135": {
  },
  "136": {
  },
  "137": {
    232: { id: 232, description: "1# Composite sensor CO suprathreshold (Battery cabinet 1)", source: "System", classification: "" },
    233: { id: 233, description: "2# Composite sensor CO suprathreshold (Battery cabinet 2)", source: "System", classification: "" },
    234: { id: 234, description: "3# Composite sensor CO suprathreshold (Battery cabinet 3)", source: "System", classification: "" },
    235: { id: 235, description: "4# Composite sensor CO suprathreshold (Battery cabinet 4)", source: "System", classification: "" },
    236: { id: 236, description: "5# Composite sensor CO suprathreshold (Battery cabinet 5) (Reserve)", source: "System", classification: "" },
    237: { id: 237, description: "6# Composite sensor CO suprathreshold (Battery cabinet 6) (Reserve)", source: "System", classification: "" },
  },
  "1A1": {
    240: { id: 240, description: "Inconsistent versions of battery cluster control", source: "System", classification: "", level: 1 },
    241: { id: 241, description: "CSU system warn", source: "System", classification: "", level: 1 },
    242: { id: 242, description: "Missing safety regulations file", source: "System", classification: "", level: 1 },
    247: { id: 247, description: "Fire controller communication fault", source: "System", classification: "", level: 1 },
    248: { id: 248, description: "Waterlogging alarm", source: "System", classification: "", level: 1 },
    249: { id: 249, description: "Fire alarm", source: "System", classification: "", level: 1 },
    250: { id: 250, description: "Battery cabinet 1 IO Unit communication fault", source: "System", classification: "", level: 1 },
    251: { id: 251, description: "Battery cabinet 2 IO Unit communication fault", source: "System", classification: "", level: 1 },
    252: { id: 252, description: "Battery cabinet 3 IO Unit communication fault", source: "System", classification: "", level: 1 },
    253: { id: 253, description: "Battery cabinet 4 IO Unit communication fault", source: "System", classification: "", level: 1 },
    254: { id: 254, description: "Battery cabinet 5 IO Unit communication fault (Reserve)", source: "System", classification: "", level: 1 },
    255: { id: 255, description: "Battery cabinet 6 IO Unit communication fault (Reserve)", source: "System", classification: "", level: 1 },
  },
  "1A2": {
    671: { id: 671, description: "Total alarm flag", source: "System", classification: "" },
    681: { id: 681, description: "Other faults (total)", source: "System", classification: "" },
    682: { id: 682, description: "Ambient temperature sensor fault", source: "System", classification: "" },
    683: { id: 683, description: "Water inlet temperature sensor fault", source: "System", classification: "" },
    684: { id: 684, description: "Water outlet temperature sensor fault", source: "System", classification: "" },
    685: { id: 685, description: "Water inlet pressure sensor fault", source: "System", classification: "" },
    686: { id: 686, description: "Water outlet pressure sensor fault", source: "System", classification: "" },
  },
  "1A3": {
    687: { id: 687, description: "Electric box 1 temperature sensor fault", source: "System", classification: "" },
    688: { id: 688, description: "EEPROM fault", source: "System", classification: "" },
    689: { id: 689, description: "Clock exception fault", source: "System", classification: "" },
    690: { id: 690, description: "Electric control box cooling fan 1 alarm", source: "System", classification: "" },
    691: { id: 691, description: "Water outlet pressure high", source: "System", classification: "" },
    692: { id: 692, description: "Water inlet pressure low", source: "System", classification: "" },
    693: { id: 693, description: "Water outlet low temperature alarm", source: "System", classification: "" },
    694: { id: 694, description: "Water outlet high temperature alarm", source: "System", classification: "" },
    695: { id: 695, description: "System 1 - Outlet temperature sensor fault", source: "System", classification: "" },
    696: { id: 696, description: "System 1 - Inlet temperature sensor fault", source: "System", classification: "" },
    697: { id: 697, description: "Fan 1 fault", source: "System", classification: "" },
    698: { id: 698, description: "Fan 2 fault", source: "System", classification: "" },
    699: { id: 699, description: "Fan 3 fault", source: "System", classification: "" },
  },
  "1A6": {
    256: { id: 256, description: "Cluster temperature alarm overall flag", source: "System", classification: "", level: 1 },
    257: { id: 257, description: "Cluster 1 Temperature alarm flag", source: "System", classification: "", level: 1 },
    258: { id: 258, description: "Cluster 2 Temperature alarm flag", source: "System", classification: "", level: 1 },
    259: { id: 259, description: "Cluster 3 Temperature alarm flag", source: "System", classification: "", level: 1 },
    260: { id: 260, description: "Cluster 4 Temperature alarm flag", source: "System", classification: "", level: 1 },
    261: { id: 261, description: "Cluster 5 Temperature alarm flag (Reserve)", source: "System", classification: "", level: 1 },
    262: { id: 262, description: "Cluster 6 Temperature alarm flag (Reserve)", source: "System", classification: "", level: 1 },
    263: { id: 263, description: "Smoke Detector 1", source: "System", classification: "", level: 1 },
    264: { id: 264, description: "Smoke Detector 2", source: "System", classification: "", level: 1 },
    265: { id: 265, description: "Smoke Detector 3", source: "System", classification: "", level: 1 },
    266: { id: 266, description: "Smoke Detector 4", source: "System", classification: "", level: 1 },
    267: { id: 267, description: "Smoke Detector 5 (Reserve)", source: "System", classification: "", level: 1 },
    268: { id: 268, description: "Smoke Detector 6 (Reserve)", source: "System", classification: "", level: 1 },
    269: { id: 269, description: "Temperature sensor 1", source: "System", classification: "", level: 1 },
    270: { id: 270, description: "Temperature sensor 2", source: "System", classification: "", level: 1 },
    271: { id: 271, description: "Temperature sensor 3", source: "System", classification: "", level: 1 },
  },
  "1A7": {
    272: { id: 272, description: "Temperature sensor 4", source: "System", classification: "", level: 1 },
    273: { id: 273, description: "Temperature sensor 5 (Reserve)", source: "System", classification: "", level: 1 },
    274: { id: 274, description: "Temperature sensor 6 (Reserve)", source: "System", classification: "", level: 1 },
    275: { id: 275, description: "1# Composite sensor Temperature warning", source: "System", classification: "", level: 1 },
    276: { id: 276, description: "2# Composite sensor Temperature warning", source: "System", classification: "", level: 1 },
    277: { id: 277, description: "3# Composite sensor Temperature warning", source: "System", classification: "", level: 1 },
    278: { id: 278, description: "4# Composite sensor Temperature warning", source: "System", classification: "", level: 1 },
    279: { id: 279, description: "5# Composite sensor Temperature warning (Reserve)", source: "System", classification: "", level: 1 },
    280: { id: 280, description: "6# Composite sensor Temperature warning (Reserve)", source: "System", classification: "", level: 1 },
    281: { id: 281, description: "1# Composite sensor PM2.5/CO warning", source: "System", classification: "", level: 1 },
    282: { id: 282, description: "2# Composite sensor PM2.5/CO warning", source: "System", classification: "", level: 1 },
    283: { id: 283, description: "3# Composite sensor PM2.5/CO warning", source: "System", classification: "", level: 1 },
    284: { id: 284, description: "4# Composite sensor PM2.5/CO warning", source: "System", classification: "", level: 1 },
    285: { id: 285, description: "5# Composite sensor PM2.5/CO warning (Reserve)", source: "System", classification: "", level: 1 },
    286: { id: 286, description: "6# Composite sensor PM2.5/CO warning (Reserve)", source: "System", classification: "", level: 1 },
    287: { id: 287, description: "1# Gas detector communication fault", source: "System", classification: "", level: 1 },
  },
  "1A8": {
    288: { id: 288, description: "2# Gas detector communication fault", source: "System", classification: "", level: 1 },
    289: { id: 289, description: "3# Gas detector communication fault", source: "System", classification: "", level: 1 },
    290: { id: 290, description: "4# Gas detector communication fault", source: "System", classification: "", level: 1 },
    291: { id: 291, description: "5# Gas detector communication fault (Reserve)", source: "System", classification: "", level: 1 },
    292: { id: 292, description: "6# Gas detector communication fault (Reserve)", source: "System", classification: "", level: 1 },
    293: { id: 293, description: "Fire cylinder 1 high pressure alarm", source: "System", classification: "", level: 1 },
    294: { id: 294, description: "Fire cylinder 2 high pressure alarm", source: "System", classification: "", level: 1 },
    295: { id: 295, description: "Fire sharing: Host Disconnection", source: "System", classification: "", level: 1 },
    296: { id: 296, description: "Fire sharing: Slave 1 Disconnection", source: "System", classification: "", level: 1 },
    297: { id: 297, description: "Fire sharing: Slave 2 Disconnection", source: "System", classification: "", level: 1 },
    298: { id: 298, description: "Fire sharing: Slave 3 Disconnection", source: "System", classification: "", level: 1 },
    299: { id: 299, description: "Fire sharing: Slave 4 Disconnection", source: "System", classification: "", level: 1 },
    300: { id: 300, description: "Fire sharing: Slave 5 Disconnection", source: "System", classification: "", level: 1 },
    301: { id: 301, description: "1/2/3/4/5/6# Fire IO unit communication fault", source: "System", classification: "", level: 1 },
  },
  "1A9": {
    304: { id: 304, description: "1# Dehumidifier disconnection", source: "System", classification: "", level: 1 },
    305: { id: 305, description: "2# Dehumidifier disconnection", source: "System", classification: "", level: 1 },
    306: { id: 306, description: "3# Dehumidifier disconnection", source: "System", classification: "", level: 1 },
    307: { id: 307, description: "4# Dehumidifier disconnection", source: "System", classification: "", level: 1 },
    308: { id: 308, description: "5# Dehumidifier disconnection (Reserve)", source: "System", classification: "", level: 1 },
    309: { id: 309, description: "6# Dehumidifier disconnection (Reserve)", source: "System", classification: "", level: 1 },
    310: { id: 310, description: "1# Internal abnormal alarm of dehumidifier", source: "System", classification: "", level: 1 },
    311: { id: 311, description: "2# Internal abnormal alarm of dehumidifier", source: "System", classification: "", level: 1 },
    312: { id: 312, description: "3# Internal abnormal alarm of dehumidifier", source: "System", classification: "", level: 1 },
    313: { id: 313, description: "4# Internal abnormal alarm of dehumidifier", source: "System", classification: "", level: 1 },
    314: { id: 314, description: "5# Internal abnormal alarm of dehumidifier (Reserve)", source: "System", classification: "", level: 1 },
    315: { id: 315, description: "6# Internal abnormal alarm of dehumidifier (Reserve)", source: "System", classification: "", level: 1 },
  },
  "2": {
    17: { id: 17, description: "CSU parallel cabinet master: communication with slave lost", source: "System", classification: "", level: 1 },
    18: { id: 18, description: "CSU parallel cabinet master: communication with combiner cabinet lost", source: "System", classification: "", level: 1 },
    19: { id: 19, description: "Combiner cabinet fault", source: "System", classification: "", level: 3 },
    20: { id: 20, description: "Photovoltaic meter1 current direction error", source: "System", classification: "", level: 1 },
    21: { id: 21, description: "Photovoltaic meter2 current direction error", source: "System", classification: "", level: 1 },
    22: { id: 22, description: "Photovoltaic meter3 current direction error", source: "System", classification: "", level: 1 },
  },
  "231": {
    320: { id: 320, description: "EPO (emergency stop) - Energy storage cabinet EPO button push", source: "System", classification: "", level: 3 },
    321: { id: 321, description: "Battery cluster power-on failure external alarm", source: "System", classification: "", level: 3 },
    322: { id: 322, description: "SPD (Surge Protective Device) signal", source: "System", classification: "", level: 3 },
    323: { id: 323, description: "pcs_poweron_fault", source: "System", classification: "", level: 3 },
    324: { id: 324, description: "Stop by external faults", source: "System", classification: "", level: 3 },
    325: { id: 325, description: "DRM0 emergency stop", source: "System", classification: "", level: 3 },
    328: { id: 328, description: "Water immersion fault", source: "System", classification: "", level: 3 },
    329: { id: 329, description: "Door magnetic fault", source: "System", classification: "", level: 3 },
    330: { id: 330, description: "Fire alarm", source: "System", classification: "", level: 3 },
  },
  "233": {
    701: { id: 701, description: "Total fault flag", source: "System", classification: "" },
    702: { id: 702, description: "Offline flag", source: "System", classification: "" },
    711: { id: 711, description: "Fault-stopping machine", source: "System", classification: "" },
    712: { id: 712, description: "Fault-stopping compressor 1", source: "System", classification: "" },
    713: { id: 713, description: "Fault-stopping compressor 2", source: "System", classification: "" },
    714: { id: 714, description: "Fault-stopping heater", source: "System", classification: "" },
    715: { id: 715, description: "Fault-stopping pump", source: "System", classification: "" },
    716: { id: 716, description: "Water inlet pressure sensor fault", source: "System", classification: "" },
  },
  "234": {
    717: { id: 717, description: "Water outlet temperature sensor fault", source: "System", classification: "" },
    718: { id: 718, description: "Water inlet pressure sensor fault", source: "System", classification: "" },
    719: { id: 719, description: "Water outlet pressure sensor fault", source: "System", classification: "" },
    720: { id: 720, description: "Voltage detection communication error", source: "System", classification: "" },
    721: { id: 721, description: "Power overvoltage alarm", source: "System", classification: "" },
    722: { id: 722, description: "Power undervoltage alarm", source: "System", classification: "" },
    723: { id: 723, description: "Pump fault", source: "System", classification: "" },
    724: { id: 724, description: "Heater overtemperature alarm 1", source: "System", classification: "" },
    725: { id: 725, description: "Monitor communication error", source: "System", classification: "" },
    726: { id: 726, description: "Water outlet pressure high", source: "System", classification: "" },
    727: { id: 727, description: "Water inlet pressure low", source: "System", classification: "" },
    728: { id: 728, description: "Water shortage alarm", source: "System", classification: "" },
    729: { id: 729, description: "System1 - Condensate pressure sensor fault", source: "System", classification: "" },
    730: { id: 730, description: "System1 - Evaporation pressure sensor fault", source: "System", classification: "" },
    731: { id: 731, description: "System1 - Condensate pressure high alarm", source: "System", classification: "" },
    732: { id: 732, description: "System1 - High condensate pressure lock", source: "System", classification: "" },
  },
  "235": {
    733: { id: 733, description: "System1 - Evaporation pressure low alarm", source: "System", classification: "" },
    734: { id: 734, description: "System1 - Low evaporation pressure lock", source: "System", classification: "" },
    735: { id: 735, description: "System1 - Outlet temperature high", source: "System", classification: "" },
    736: { id: 736, description: "System1 - Outlet high temperature lock", source: "System", classification: "" },
    737: { id: 737, description: "System1 - Drive module overtemperature", source: "System", classification: "" },
    738: { id: 738, description: "System1 - Current high", source: "System", classification: "" },
    739: { id: 739, description: "System1 - Drive not match", source: "System", classification: "" },
    740: { id: 740, description: "System1 - Drive alarm", source: "System", classification: "" },
    741: { id: 741, description: "System1 - Drive communication error", source: "System", classification: "" },
    742: { id: 742, description: "System1 - Drive lock", source: "System", classification: "" },
    743: { id: 743, description: "System1 - EEV drive alarm", source: "System", classification: "" },
    744: { id: 744, description: "System1 - Temp_eev low alarm", source: "System", classification: "" },
    745: { id: 745, description: "System1 - Temp_eev low lock", source: "System", classification: "" },
    746: { id: 746, description: "System1 - Inverting temperature sensor fault", source: "System", classification: "" },
    747: { id: 747, description: "System1 - High voltage switch alarm lock", source: "System", classification: "" },
    748: { id: 748, description: "System1 - High voltage switch alarm lock", source: "System", classification: "" },
  },
  "236": {
    749: { id: 749, description: "System1 - Freeze protection", source: "System", classification: "" },
    750: { id: 750, description: "System1 fault", source: "System", classification: "" },
  },
  "237": {
    336: { id: 336, description: "Fire extinguishing agent activation sign", source: "System", classification: "", level: 3 },
    337: { id: 337, description: "Cluster 1 Temperature alarm flag", source: "System", classification: "", level: 3 },
    338: { id: 338, description: "Cluster 2 Temperature alarm flag", source: "System", classification: "", level: 3 },
    339: { id: 339, description: "Cluster 3 Temperature alarm flag", source: "System", classification: "", level: 3 },
    340: { id: 340, description: "Cluster 4 Temperature alarm flag", source: "System", classification: "", level: 3 },
    341: { id: 341, description: "Cluster 5 Temperature alarm flag (Reserve)", source: "System", classification: "", level: 3 },
    342: { id: 342, description: "Cluster 6 Temperature alarm flag (Reserve)", source: "System", classification: "", level: 3 },
    343: { id: 343, description: "PACK Temperature + 1#CO alarm", source: "System", classification: "", level: 3 },
    344: { id: 344, description: "PACK Temperature + 2#CO alarm", source: "System", classification: "", level: 3 },
    345: { id: 345, description: "PACK Temperature + 3#CO alarm", source: "System", classification: "", level: 3 },
    346: { id: 346, description: "PACK Temperature + 4#CO alarm", source: "System", classification: "", level: 3 },
    347: { id: 347, description: "PACK Temperature + 5#CO alarm (Reserve)", source: "System", classification: "", level: 3 },
    348: { id: 348, description: "PACK Temperature + 6#CO alarm (Reserve)", source: "System", classification: "", level: 3 },
    349: { id: 349, description: "1# Smoke Detector + Temperature sensor alarm", source: "System", classification: "", level: 3 },
    350: { id: 350, description: "2# Smoke Detector + Temperature sensor alarm", source: "System", classification: "", level: 3 },
    351: { id: 351, description: "3# Smoke Detector + Temperature sensor alarm", source: "System", classification: "", level: 3 },
  },
  "238": {
    352: { id: 352, description: "4# Smoke Detector + Temperature sensor alarm", source: "System", classification: "", level: 3 },
    353: { id: 353, description: "5# Smoke Detector + Temperature sensor alarm (Reserve)", source: "System", classification: "", level: 3 },
    354: { id: 354, description: "6# Smoke Detector + Temperature sensor alarm (Reserve)", source: "System", classification: "", level: 3 },
    355: { id: 355, description: "Smoke Detector + 1# Composite sensor: Temperature", source: "System", classification: "", level: 3 },
    356: { id: 356, description: "Smoke Detector + 2# Composite sensor: Temperature", source: "System", classification: "", level: 3 },
    357: { id: 357, description: "Smoke Detector + 3# Composite sensor: Temperature", source: "System", classification: "", level: 3 },
    358: { id: 358, description: "Smoke Detector + 4# Composite sensor: Temperature", source: "System", classification: "", level: 3 },
    359: { id: 359, description: "Smoke Detector + 5# Composite sensor: Temperature (Reserve)", source: "System", classification: "", level: 3 },
    360: { id: 360, description: "Smoke Detector + 6# Composite sensor: Temperature (Reserve)", source: "System", classification: "", level: 3 },
    361: { id: 361, description: "Temperature sensor + 1# Composite sensor: CO", source: "System", classification: "", level: 3 },
    362: { id: 362, description: "Temperature sensor + 2# Composite sensor: CO", source: "System", classification: "", level: 3 },
    363: { id: 363, description: "Temperature sensor + 3# Composite sensor: CO", source: "System", classification: "", level: 3 },
    364: { id: 364, description: "Temperature sensor + 4# Composite sensor: CO", source: "System", classification: "", level: 3 },
    365: { id: 365, description: "Temperature sensor + 5# Composite sensor: CO (Reserve)", source: "System", classification: "", level: 3 },
    366: { id: 366, description: "Temperature sensor + 6# Composite sensor: CO (Reserve)", source: "System", classification: "", level: 3 },
    367: { id: 367, description: "CMU starts fire protection", source: "System", classification: "", level: 3 },
  },
  "239": {
    368: { id: 368, description: "Fire hazards in the system (one subsystem has a second-level fire alarm)", source: "System", classification: "", level: 3 },
    369: { id: 369, description: "PACK Temperature rise + 1#CO alarm", source: "System", classification: "", level: 3 },
    370: { id: 370, description: "PACK Temperature rise + 2#CO alarm", source: "System", classification: "", level: 3 },
    371: { id: 371, description: "PACK Temperature rise + 3#CO alarm", source: "System", classification: "", level: 3 },
    372: { id: 372, description: "PACK Temperature rise + 4#CO alarm", source: "System", classification: "", level: 3 },
    373: { id: 373, description: "PACK Temperature rise + 5#CO alarm (Reserve)", source: "System", classification: "", level: 3 },
    374: { id: 374, description: "PACK Temperature rise + 6#CO alarm (Reserve)", source: "System", classification: "", level: 3 },
    376: { id: 376, description: "PCS Fault", source: "System", classification: "", level: 3 },
  },
  "2C1": {
    768: { id: 768, description: "DI4 status (Emergency-stop signal)", source: "System", classification: "" },
    769: { id: 769, description: "DI5 status (Upper level monitoring fault signal)", source: "System", classification: "" },
  },
  "2E1": {
    781: { id: 781, description: "Power supply voltage undervoltage alarm", source: "System", classification: "", level: 1 },
    782: { id: 782, description: "Power supply voltage overvoltage alarm", source: "System", classification: "", level: 1 },
    783: { id: 783, description: "PACK temperature overtemperature alarm", source: "System", classification: "", level: 1 },
    784: { id: 784, description: "Cluster end voltage undervoltage alarm", source: "System", classification: "", level: 1 },
    785: { id: 785, description: "Cluster terminal voltage overvoltage alarm", source: "System", classification: "", level: 1 },
    786: { id: 786, description: "Charging overcurrent alarm", source: "System", classification: "", level: 1 },
    787: { id: 787, description: "Power terminal overtemperature alarm", source: "System", classification: "", level: 1 },
    788: { id: 788, description: "Feed current overcurrent alarm", source: "System", classification: "", level: 1 },
    789: { id: 789, description: "Discharge overcurrent alarm", source: "System", classification: "", level: 1 },
    790: { id: 790, description: "Low insulation alarm", source: "System", classification: "", level: 1 },
    791: { id: 791, description: "SOC low alarm", source: "System", classification: "", level: 1 },
    792: { id: 792, description: "SOC ultra high alarm", source: "System", classification: "", level: 1 },
    793: { id: 793, description: "Battery cell voltage overvoltage alarm", source: "System", classification: "", level: 1 },
    794: { id: 794, description: "Battery cell voltage undervoltage alarm", source: "System", classification: "", level: 1 },
    795: { id: 795, description: "Battery cell voltage difference alarm", source: "System", classification: "", level: 1 },
    796: { id: 796, description: "Charging battery cell overtemperature alarm", source: "System", classification: "", level: 1 },
  },
  "2E2": {
    797: { id: 797, description: "Charging battery cell undertemperature alarm", source: "System", classification: "", level: 1 },
    798: { id: 798, description: "Discharge battery cell overtemperature alarm", source: "System", classification: "", level: 1 },
    799: { id: 799, description: "Discharge battery cell undertemperature alarm", source: "System", classification: "", level: 1 },
    800: { id: 800, description: "Battery cell temperature difference alarm", source: "System", classification: "", level: 1 },
    801: { id: 801, description: "SOC differential over threshold alarm", source: "System", classification: "", level: 1 },
    802: { id: 802, description: "Temperature rise over threshold alarm", source: "System", classification: "", level: 1 },
    803: { id: 803, description: "PACK overvoltage alarm", source: "System", classification: "", level: 1 },
    804: { id: 804, description: "PACK undervoltage alarm", source: "System", classification: "", level: 1 },
    805: { id: 805, description: "Power supply voltage undervoltage alarm", source: "System", classification: "", level: 2 },
    806: { id: 806, description: "Power supply voltage overvoltage alarm", source: "System", classification: "", level: 2 },
    807: { id: 807, description: "PACK temperature overtemperature alarm", source: "System", classification: "", level: 2 },
    808: { id: 808, description: "Cluster end voltage undervoltage alarm", source: "System", classification: "", level: 2 },
    809: { id: 809, description: "Cluster terminal voltage overvoltage alarm", source: "System", classification: "", level: 2 },
    810: { id: 810, description: "Charging overcurrent alarm", source: "System", classification: "", level: 2 },
    811: { id: 811, description: "Power terminal overtemperature alarm", source: "System", classification: "", level: 2 },
    812: { id: 812, description: "Feed current overcurrent alarm", source: "System", classification: "", level: 2 },
  },
  "2E3": {
    813: { id: 813, description: "Discharge overcurrent alarm", source: "System", classification: "", level: 2 },
    814: { id: 814, description: "Low insulation alarm", source: "System", classification: "", level: 2 },
    817: { id: 817, description: "Battery cell voltage overvoltage alarm", source: "System", classification: "", level: 2 },
    818: { id: 818, description: "Battery cell voltage undervoltage alarm", source: "System", classification: "", level: 2 },
    819: { id: 819, description: "Battery cell voltage difference alarm", source: "System", classification: "", level: 2 },
    820: { id: 820, description: "Charging battery cell overtemperature alarm", source: "System", classification: "", level: 2 },
    821: { id: 821, description: "Charging battery cell undertemperature alarm", source: "System", classification: "", level: 2 },
    822: { id: 822, description: "Discharge battery cell overtemperature alarm", source: "System", classification: "", level: 2 },
    823: { id: 823, description: "Discharge battery cell undertemperature alarm", source: "System", classification: "", level: 2 },
    824: { id: 824, description: "Battery cell temperature difference alarm", source: "System", classification: "", level: 2 },
    825: { id: 825, description: "SOC differential over threshold alarm", source: "System", classification: "", level: 2 },
    826: { id: 826, description: "Temperature rise over threshold alarm", source: "System", classification: "", level: 2 },
    827: { id: 827, description: "PACK overvoltage alarm", source: "System", classification: "", level: 2 },
    828: { id: 828, description: "PACK undervoltage alarm", source: "System", classification: "", level: 2 },
  },
  "2E4": {
    829: { id: 829, description: "Power supply voltage undervoltage alarm", source: "System", classification: "", level: 3 },
    830: { id: 830, description: "Power supply voltage overvoltage alarm", source: "System", classification: "", level: 3 },
    831: { id: 831, description: "PACK temperature overtemperature alarm", source: "System", classification: "", level: 3 },
    832: { id: 832, description: "Cluster end voltage undervoltage alarm", source: "System", classification: "", level: 3 },
    833: { id: 833, description: "Cluster terminal voltage overvoltage alarm", source: "System", classification: "", level: 3 },
    834: { id: 834, description: "Charging overcurrent alarm", source: "System", classification: "", level: 3 },
    835: { id: 835, description: "Power terminal overtemperature alarm", source: "System", classification: "", level: 3 },
    836: { id: 836, description: "Feed current overcurrent alarm", source: "System", classification: "", level: 3 },
    837: { id: 837, description: "Discharge overcurrent alarm", source: "System", classification: "", level: 3 },
    838: { id: 838, description: "Low insulation alarm", source: "System", classification: "", level: 3 },
    841: { id: 841, description: "Battery cell voltage overvoltage alarm", source: "System", classification: "", level: 3 },
    842: { id: 842, description: "Battery cell voltage undervoltage alarm", source: "System", classification: "", level: 3 },
    843: { id: 843, description: "Battery cell voltage difference alarm", source: "System", classification: "", level: 3 },
    844: { id: 844, description: "Charging battery cell overtemperature alarm", source: "System", classification: "", level: 3 },
  },
  "2E5": {
    845: { id: 845, description: "Charging battery cell undertemperature alarm", source: "System", classification: "", level: 3 },
    846: { id: 846, description: "Discharge battery cell overtemperature alarm", source: "System", classification: "", level: 3 },
    847: { id: 847, description: "Discharge battery cell undertemperature alarm", source: "System", classification: "", level: 3 },
    848: { id: 848, description: "Battery cell temperature difference alarm", source: "System", classification: "", level: 3 },
    849: { id: 849, description: "SOC differential over threshold alarm", source: "System", classification: "", level: 3 },
    850: { id: 850, description: "Temperature rise over threshold alarm", source: "System", classification: "", level: 3 },
    851: { id: 851, description: "PACK overvoltage alarm", source: "System", classification: "", level: 3 },
    852: { id: 852, description: "PACK undervoltage alarm", source: "System", classification: "", level: 3 },
    853: { id: 853, description: "CMU–BCU communication fault", source: "System", classification: "", level: 2 },
    854: { id: 854, description: "SOH low alarm", source: "System", classification: "", level: 1 },
  },
  "31": {
    39: { id: 39, description: "SPD1 fault status", source: "System", classification: "" },
    40: { id: 40, description: "AC SPD fault status", source: "System", classification: "" },
    41: { id: 41, description: "SPD2 fault status", source: "System", classification: "" },
    46: { id: 46, description: "Insulation detection equipment fault status", source: "System", classification: "" },
    47: { id: 47, description: "Insulation detection fault status", source: "System", classification: "" },
    48: { id: 48, description: "Energy storage cabinet fault status", source: "System", classification: "" },
  },
  "32": {
    49: { id: 49, description: "Remote emergency stop fault status", source: "System", classification: "" },
  },
  "3C1": {
    1768: { id: 1768, description: "DI4 status (Emergency-stop signal)", source: "System", classification: "" },
    1769: { id: 1769, description: "DI5 status (Upper level monitoring fault signal)", source: "System", classification: "" },
  },
  "3E1": {
    1781: { id: 1781, description: "Power supply voltage undervoltage alarm", source: "System", classification: "", level: 1 },
    1782: { id: 1782, description: "Power supply voltage overvoltage alarm", source: "System", classification: "", level: 1 },
    1783: { id: 1783, description: "PACK temperature overtemperature alarm", source: "System", classification: "", level: 1 },
    1784: { id: 1784, description: "Cluster end voltage undervoltage alarm", source: "System", classification: "", level: 1 },
    1785: { id: 1785, description: "Cluster terminal voltage overvoltage alarm", source: "System", classification: "", level: 1 },
    1786: { id: 1786, description: "Charging overcurrent alarm", source: "System", classification: "", level: 1 },
    1787: { id: 1787, description: "Power terminal overtemperature alarm", source: "System", classification: "", level: 1 },
    1788: { id: 1788, description: "Feed current overcurrent alarm", source: "System", classification: "", level: 1 },
    1789: { id: 1789, description: "Discharge overcurrent alarm", source: "System", classification: "", level: 1 },
    1790: { id: 1790, description: "Low insulation alarm", source: "System", classification: "", level: 1 },
    1791: { id: 1791, description: "SOC low alarm", source: "System", classification: "", level: 1 },
    1792: { id: 1792, description: "SOC ultra high alarm", source: "System", classification: "", level: 1 },
    1793: { id: 1793, description: "Battery cell voltage overvoltage alarm", source: "System", classification: "", level: 1 },
    1794: { id: 1794, description: "Battery cell voltage undervoltage alarm", source: "System", classification: "", level: 1 },
    1795: { id: 1795, description: "Battery cell voltage difference alarm", source: "System", classification: "", level: 1 },
    1796: { id: 1796, description: "Charging battery cell overtemperature alarm", source: "System", classification: "", level: 1 },
  },
  "3E2": {
    1797: { id: 1797, description: "Charging battery cell undertemperature alarm", source: "System", classification: "", level: 1 },
    1798: { id: 1798, description: "Discharge battery cell overtemperature alarm", source: "System", classification: "", level: 1 },
    1799: { id: 1799, description: "Discharge battery cell undertemperature alarm", source: "System", classification: "", level: 1 },
    1800: { id: 1800, description: "Battery cell temperature difference alarm", source: "System", classification: "", level: 1 },
    1801: { id: 1801, description: "SOC differential over threshold alarm", source: "System", classification: "", level: 1 },
    1802: { id: 1802, description: "Temperature rise over threshold alarm", source: "System", classification: "", level: 1 },
    1803: { id: 1803, description: "PACK overvoltage alarm", source: "System", classification: "", level: 1 },
    1804: { id: 1804, description: "PACK undervoltage alarm", source: "System", classification: "", level: 1 },
    1805: { id: 1805, description: "Power supply voltage undervoltage alarm", source: "System", classification: "", level: 2 },
    1806: { id: 1806, description: "Power supply voltage overvoltage alarm", source: "System", classification: "", level: 2 },
    1807: { id: 1807, description: "PACK temperature overtemperature alarm", source: "System", classification: "", level: 2 },
    1808: { id: 1808, description: "Cluster end voltage undervoltage alarm", source: "System", classification: "", level: 2 },
    1809: { id: 1809, description: "Cluster terminal voltage overvoltage alarm", source: "System", classification: "", level: 2 },
    1810: { id: 1810, description: "Charging overcurrent alarm", source: "System", classification: "", level: 2 },
    1811: { id: 1811, description: "Power terminal overtemperature alarm", source: "System", classification: "", level: 2 },
    1812: { id: 1812, description: "Feed current overcurrent alarm", source: "System", classification: "", level: 2 },
  },
  "3E3": {
    1813: { id: 1813, description: "Discharge overcurrent alarm", source: "System", classification: "", level: 2 },
    1814: { id: 1814, description: "Low insulation alarm", source: "System", classification: "", level: 2 },
    1817: { id: 1817, description: "Battery cell voltage overvoltage alarm", source: "System", classification: "", level: 2 },
    1818: { id: 1818, description: "Battery cell voltage undervoltage alarm", source: "System", classification: "", level: 2 },
    1819: { id: 1819, description: "Battery cell voltage difference alarm", source: "System", classification: "", level: 2 },
    1820: { id: 1820, description: "Charging battery cell overtemperature alarm", source: "System", classification: "", level: 2 },
    1821: { id: 1821, description: "Charging battery cell undertemperature alarm", source: "System", classification: "", level: 2 },
    1822: { id: 1822, description: "Discharge battery cell overtemperature alarm", source: "System", classification: "", level: 2 },
    1823: { id: 1823, description: "Discharge battery cell undertemperature alarm", source: "System", classification: "", level: 2 },
    1824: { id: 1824, description: "Battery cell temperature difference alarm", source: "System", classification: "", level: 2 },
    1825: { id: 1825, description: "SOC differential over threshold alarm", source: "System", classification: "", level: 2 },
    1826: { id: 1826, description: "Temperature rise over threshold alarm", source: "System", classification: "", level: 2 },
    1827: { id: 1827, description: "PACK overvoltage alarm", source: "System", classification: "", level: 2 },
    1828: { id: 1828, description: "PACK undervoltage alarm", source: "System", classification: "", level: 2 },
  },
  "3E4": {
    1829: { id: 1829, description: "Power supply voltage undervoltage alarm", source: "System", classification: "", level: 3 },
    1830: { id: 1830, description: "Power supply voltage overvoltage alarm", source: "System", classification: "", level: 3 },
    1831: { id: 1831, description: "PACK temperature overtemperature alarm", source: "System", classification: "", level: 3 },
    1832: { id: 1832, description: "Cluster end voltage undervoltage alarm", source: "System", classification: "", level: 3 },
    1833: { id: 1833, description: "Cluster terminal voltage overvoltage alarm", source: "System", classification: "", level: 3 },
    1834: { id: 1834, description: "Charging overcurrent alarm", source: "System", classification: "", level: 3 },
    1835: { id: 1835, description: "Power terminal overtemperature alarm", source: "System", classification: "", level: 3 },
    1836: { id: 1836, description: "Feed current overcurrent alarm", source: "System", classification: "", level: 3 },
    1837: { id: 1837, description: "Discharge overcurrent alarm", source: "System", classification: "", level: 3 },
    1838: { id: 1838, description: "Low insulation alarm", source: "System", classification: "", level: 3 },
    1841: { id: 1841, description: "Battery cell voltage overvoltage alarm", source: "System", classification: "", level: 3 },
    1842: { id: 1842, description: "Battery cell voltage undervoltage alarm", source: "System", classification: "", level: 3 },
    1843: { id: 1843, description: "Battery cell voltage difference alarm", source: "System", classification: "", level: 3 },
    1844: { id: 1844, description: "Charging battery cell overtemperature alarm", source: "System", classification: "", level: 3 },
  },
  "3E5": {
    1845: { id: 1845, description: "Charging battery cell undertemperature alarm", source: "System", classification: "", level: 3 },
    1846: { id: 1846, description: "Discharge battery cell overtemperature alarm", source: "System", classification: "", level: 3 },
    1847: { id: 1847, description: "Discharge battery cell undertemperature alarm", source: "System", classification: "", level: 3 },
    1848: { id: 1848, description: "Battery cell temperature difference alarm", source: "System", classification: "", level: 3 },
    1849: { id: 1849, description: "SOC differential over threshold alarm", source: "System", classification: "", level: 3 },
    1850: { id: 1850, description: "Temperature rise over threshold alarm", source: "System", classification: "", level: 3 },
    1851: { id: 1851, description: "PACK overvoltage alarm", source: "System", classification: "", level: 3 },
    1852: { id: 1852, description: "PACK undervoltage alarm", source: "System", classification: "", level: 3 },
    1853: { id: 1853, description: "CMU-BCU communication fault", source: "System", classification: "", level: 2 },
    1854: { id: 1854, description: "SOH low alarm", source: "System", classification: "", level: 1 },
  },
  "4C1": {
    2768: { id: 2768, description: "DI4 status (Emergency-stop signal)", source: "System", classification: "" },
    2769: { id: 2769, description: "DI5 status (Upper level monitoring fault signal)", source: "System", classification: "" },
  },
  "4E1": {
    2781: { id: 2781, description: "Power supply voltage undervoltage alarm", source: "System", classification: "", level: 1 },
    2782: { id: 2782, description: "Power supply voltage overvoltage alarm", source: "System", classification: "", level: 1 },
    2783: { id: 2783, description: "PACK temperature overtemperature alarm", source: "System", classification: "", level: 1 },
    2784: { id: 2784, description: "Cluster end voltage undervoltage alarm", source: "System", classification: "", level: 1 },
    2785: { id: 2785, description: "Cluster terminal voltage overvoltage alarm", source: "System", classification: "", level: 1 },
    2786: { id: 2786, description: "Charging overcurrent alarm", source: "System", classification: "", level: 1 },
    2787: { id: 2787, description: "Power terminal overtemperature alarm", source: "System", classification: "", level: 1 },
    2788: { id: 2788, description: "Feed current overcurrent alarm", source: "System", classification: "", level: 1 },
    2789: { id: 2789, description: "Discharge overcurrent alarm", source: "System", classification: "", level: 1 },
    2790: { id: 2790, description: "Low insulation alarm", source: "System", classification: "", level: 1 },
    2791: { id: 2791, description: "SOC low alarm", source: "System", classification: "", level: 1 },
    2792: { id: 2792, description: "SOC ultra high alarm", source: "System", classification: "", level: 1 },
    2793: { id: 2793, description: "Battery cell voltage overvoltage alarm", source: "System", classification: "", level: 1 },
    2794: { id: 2794, description: "Battery cell voltage undervoltage alarm", source: "System", classification: "", level: 1 },
    2795: { id: 2795, description: "Battery cell voltage difference alarm", source: "System", classification: "", level: 1 },
    2796: { id: 2796, description: "Charging battery cell overtemperature alarm", source: "System", classification: "", level: 1 },
  },
  "4E2": {
    2797: { id: 2797, description: "Charging battery cell undertemperature alarm", source: "System", classification: "", level: 1 },
    2798: { id: 2798, description: "Discharge battery cell overtemperature alarm", source: "System", classification: "", level: 1 },
    2799: { id: 2799, description: "Discharge battery cell undertemperature alarm", source: "System", classification: "", level: 1 },
    2800: { id: 2800, description: "Battery cell temperature difference alarm", source: "System", classification: "", level: 1 },
    2801: { id: 2801, description: "SOC differential over threshold alarm", source: "System", classification: "", level: 1 },
    2802: { id: 2802, description: "Temperature rise over threshold alarm", source: "System", classification: "", level: 1 },
    2803: { id: 2803, description: "PACK overvoltage alarm", source: "System", classification: "", level: 1 },
    2804: { id: 2804, description: "PACK undervoltage alarm", source: "System", classification: "", level: 1 },
    2805: { id: 2805, description: "Power supply voltage undervoltage alarm", source: "System", classification: "", level: 2 },
    2806: { id: 2806, description: "Power supply voltage overvoltage alarm", source: "System", classification: "", level: 2 },
    2807: { id: 2807, description: "PACK temperature overtemperature alarm", source: "System", classification: "", level: 2 },
    2808: { id: 2808, description: "Cluster end voltage undervoltage alarm", source: "System", classification: "", level: 2 },
    2809: { id: 2809, description: "Cluster terminal voltage overvoltage alarm", source: "System", classification: "", level: 2 },
    2810: { id: 2810, description: "Charging overcurrent alarm", source: "System", classification: "", level: 2 },
    2811: { id: 2811, description: "Power terminal overtemperature alarm", source: "System", classification: "", level: 2 },
    2812: { id: 2812, description: "Feed current overcurrent alarm", source: "System", classification: "", level: 2 },
  },
  "4E3": {
    2813: { id: 2813, description: "Discharge overcurrent alarm", source: "System", classification: "", level: 2 },
    2814: { id: 2814, description: "Low insulation alarm", source: "System", classification: "", level: 2 },
    2817: { id: 2817, description: "Battery cell voltage overvoltage alarm", source: "System", classification: "", level: 2 },
    2818: { id: 2818, description: "Battery cell voltage undervoltage alarm", source: "System", classification: "", level: 2 },
    2819: { id: 2819, description: "Battery cell voltage difference alarm", source: "System", classification: "", level: 2 },
    2820: { id: 2820, description: "Charging battery cell overtemperature alarm", source: "System", classification: "", level: 2 },
    2821: { id: 2821, description: "Charging battery cell undertemperature alarm", source: "System", classification: "", level: 2 },
    2822: { id: 2822, description: "Discharge battery cell overtemperature alarm", source: "System", classification: "", level: 2 },
    2823: { id: 2823, description: "Discharge battery cell undertemperature alarm", source: "System", classification: "", level: 2 },
    2824: { id: 2824, description: "Battery cell temperature difference alarm", source: "System", classification: "", level: 2 },
    2825: { id: 2825, description: "SOC differential over threshold alarm", source: "System", classification: "", level: 2 },
    2826: { id: 2826, description: "Temperature rise over threshold alarm", source: "System", classification: "", level: 2 },
    2827: { id: 2827, description: "PACK overvoltage alarm", source: "System", classification: "", level: 2 },
    2828: { id: 2828, description: "PACK undervoltage alarm", source: "System", classification: "", level: 2 },
  },
  "4E4": {
    2829: { id: 2829, description: "Power supply voltage undervoltage alarm", source: "System", classification: "", level: 3 },
    2830: { id: 2830, description: "Power supply voltage overvoltage alarm", source: "System", classification: "", level: 3 },
    2831: { id: 2831, description: "PACK temperature overtemperature alarm", source: "System", classification: "", level: 3 },
    2832: { id: 2832, description: "Cluster end voltage undervoltage alarm", source: "System", classification: "", level: 3 },
    2833: { id: 2833, description: "Cluster terminal voltage overvoltage alarm", source: "System", classification: "", level: 3 },
    2834: { id: 2834, description: "Charging overcurrent alarm", source: "System", classification: "", level: 3 },
    2835: { id: 2835, description: "Power terminal overtemperature alarm", source: "System", classification: "", level: 3 },
    2836: { id: 2836, description: "Feed current overcurrent alarm", source: "System", classification: "", level: 3 },
    2837: { id: 2837, description: "Discharge overcurrent alarm", source: "System", classification: "", level: 3 },
    2838: { id: 2838, description: "Low insulation alarm", source: "System", classification: "", level: 3 },
    2841: { id: 2841, description: "Battery cell voltage overvoltage alarm", source: "System", classification: "", level: 3 },
    2842: { id: 2842, description: "Battery cell voltage undervoltage alarm", source: "System", classification: "", level: 3 },
    2843: { id: 2843, description: "Battery cell voltage difference alarm", source: "System", classification: "", level: 3 },
    2844: { id: 2844, description: "Charging battery cell overtemperature alarm", source: "System", classification: "", level: 3 },
  },
  "4E5": {
    2845: { id: 2845, description: "Charging battery cell undertemperature alarm", source: "System", classification: "", level: 3 },
    2846: { id: 2846, description: "Discharge battery cell overtemperature alarm", source: "System", classification: "", level: 3 },
    2847: { id: 2847, description: "Discharge battery cell undertemperature alarm", source: "System", classification: "", level: 3 },
    2848: { id: 2848, description: "Battery cell temperature difference alarm", source: "System", classification: "", level: 3 },
    2849: { id: 2849, description: "SOC differential over threshold alarm", source: "System", classification: "", level: 3 },
    2850: { id: 2850, description: "Temperature rise over threshold alarm", source: "System", classification: "", level: 3 },
    2851: { id: 2851, description: "PACK overvoltage alarm", source: "System", classification: "", level: 3 },
    2852: { id: 2852, description: "PACK undervoltage alarm", source: "System", classification: "", level: 3 },
    2853: { id: 2853, description: "CMU-BCU communication fault", source: "System", classification: "", level: 2 },
    2854: { id: 2854, description: "SOH low alarm", source: "System", classification: "", level: 1 },
  },
  "5C1": {
    3768: { id: 3768, description: "DI4 status (Emergency-stop signal)", source: "System", classification: "" },
    3769: { id: 3769, description: "DI5 status (Upper level monitoring fault signal)", source: "System", classification: "" },
  },
  "5E1": {
    3781: { id: 3781, description: "Power supply voltage undervoltage alarm", source: "System", classification: "", level: 1 },
    3782: { id: 3782, description: "Power supply voltage overvoltage alarm", source: "System", classification: "", level: 1 },
    3783: { id: 3783, description: "PACK temperature overtemperature alarm", source: "System", classification: "", level: 1 },
    3784: { id: 3784, description: "Cluster end voltage undervoltage alarm", source: "System", classification: "", level: 1 },
    3785: { id: 3785, description: "Cluster terminal voltage overvoltage alarm", source: "System", classification: "", level: 1 },
    3786: { id: 3786, description: "Charging overcurrent alarm", source: "System", classification: "", level: 1 },
    3787: { id: 3787, description: "Power terminal overtemperature alarm", source: "System", classification: "", level: 1 },
    3788: { id: 3788, description: "Feed current overcurrent alarm", source: "System", classification: "", level: 1 },
    3789: { id: 3789, description: "Discharge overcurrent alarm", source: "System", classification: "", level: 1 },
    3790: { id: 3790, description: "Low insulation alarm", source: "System", classification: "", level: 1 },
    3791: { id: 3791, description: "SOC low alarm", source: "System", classification: "", level: 1 },
    3792: { id: 3792, description: "SOC ultra high alarm", source: "System", classification: "", level: 1 },
    3793: { id: 3793, description: "Battery cell voltage overvoltage alarm", source: "System", classification: "", level: 1 },
    3794: { id: 3794, description: "Battery cell voltage undervoltage alarm", source: "System", classification: "", level: 1 },
    3795: { id: 3795, description: "Battery cell voltage difference alarm", source: "System", classification: "", level: 1 },
    3796: { id: 3796, description: "Charging battery cell overtemperature alarm", source: "System", classification: "", level: 1 },
  },
  "5E2": {
    3797: { id: 3797, description: "Charging battery cell undertemperature alarm", source: "System", classification: "", level: 1 },
    3798: { id: 3798, description: "Discharge battery cell overtemperature alarm", source: "System", classification: "", level: 1 },
    3799: { id: 3799, description: "Discharge battery cell undertemperature alarm", source: "System", classification: "", level: 1 },
    3800: { id: 3800, description: "Battery cell temperature difference alarm", source: "System", classification: "", level: 1 },
    3801: { id: 3801, description: "SOC differential over threshold alarm", source: "System", classification: "", level: 1 },
    3802: { id: 3802, description: "Temperature rise over threshold alarm", source: "System", classification: "", level: 1 },
    3803: { id: 3803, description: "PACK overvoltage alarm", source: "System", classification: "", level: 1 },
    3804: { id: 3804, description: "PACK undervoltage alarm", source: "System", classification: "", level: 1 },
    3805: { id: 3805, description: "Power supply voltage undervoltage alarm", source: "System", classification: "", level: 2 },
    3806: { id: 3806, description: "Power supply voltage overvoltage alarm", source: "System", classification: "", level: 2 },
    3807: { id: 3807, description: "PACK temperature overtemperature alarm", source: "System", classification: "", level: 2 },
    3808: { id: 3808, description: "Cluster end voltage undervoltage alarm", source: "System", classification: "", level: 2 },
    3809: { id: 3809, description: "Cluster terminal voltage overvoltage alarm", source: "System", classification: "", level: 2 },
    3810: { id: 3810, description: "Charging overcurrent alarm", source: "System", classification: "", level: 2 },
    3811: { id: 3811, description: "Power terminal overtemperature alarm", source: "System", classification: "", level: 2 },
    3812: { id: 3812, description: "Feed current overcurrent alarm", source: "System", classification: "", level: 2 },
  },
  "5E3": {
    3813: { id: 3813, description: "Discharge overcurrent alarm", source: "System", classification: "", level: 2 },
    3814: { id: 3814, description: "Low insulation alarm", source: "System", classification: "", level: 2 },
    3817: { id: 3817, description: "Battery cell voltage overvoltage alarm", source: "System", classification: "", level: 2 },
    3818: { id: 3818, description: "Battery cell voltage undervoltage alarm", source: "System", classification: "", level: 2 },
    3819: { id: 3819, description: "Battery cell voltage difference alarm", source: "System", classification: "", level: 2 },
    3820: { id: 3820, description: "Charging battery cell overtemperature alarm", source: "System", classification: "", level: 2 },
    3821: { id: 3821, description: "Charging battery cell undertemperature alarm", source: "System", classification: "", level: 2 },
    3822: { id: 3822, description: "Discharge battery cell overtemperature alarm", source: "System", classification: "", level: 2 },
    3823: { id: 3823, description: "Discharge battery cell undertemperature alarm", source: "System", classification: "", level: 2 },
    3824: { id: 3824, description: "Battery cell temperature difference alarm", source: "System", classification: "", level: 2 },
    3825: { id: 3825, description: "SOC differential over threshold alarm", source: "System", classification: "", level: 2 },
    3826: { id: 3826, description: "Temperature rise over threshold alarm", source: "System", classification: "", level: 2 },
    3827: { id: 3827, description: "PACK overvoltage alarm", source: "System", classification: "", level: 2 },
    3828: { id: 3828, description: "PACK undervoltage alarm", source: "System", classification: "", level: 2 },
  },
  "5E4": {
    3829: { id: 3829, description: "Power supply voltage undervoltage alarm", source: "System", classification: "", level: 3 },
    3830: { id: 3830, description: "Power supply voltage overvoltage alarm", source: "System", classification: "", level: 3 },
    3831: { id: 3831, description: "PACK temperature overtemperature alarm", source: "System", classification: "", level: 3 },
    3832: { id: 3832, description: "Cluster end voltage undervoltage alarm", source: "System", classification: "", level: 3 },
    3833: { id: 3833, description: "Cluster terminal voltage overvoltage alarm", source: "System", classification: "", level: 3 },
    3834: { id: 3834, description: "Charging overcurrent alarm", source: "System", classification: "", level: 3 },
    3835: { id: 3835, description: "Power terminal overtemperature alarm", source: "System", classification: "", level: 3 },
    3836: { id: 3836, description: "Feed current overcurrent alarm", source: "System", classification: "", level: 3 },
    3837: { id: 3837, description: "Discharge overcurrent alarm", source: "System", classification: "", level: 3 },
    3838: { id: 3838, description: "Low insulation alarm", source: "System", classification: "", level: 3 },
    3841: { id: 3841, description: "Battery cell voltage overvoltage alarm", source: "System", classification: "", level: 3 },
    3842: { id: 3842, description: "Battery cell voltage undervoltage alarm", source: "System", classification: "", level: 3 },
    3843: { id: 3843, description: "Battery cell voltage difference alarm", source: "System", classification: "", level: 3 },
    3844: { id: 3844, description: "Charging battery cell overtemperature alarm", source: "System", classification: "", level: 3 },
  },
  "5E5": {
    3845: { id: 3845, description: "Charging battery cell undertemperature alarm", source: "System", classification: "", level: 3 },
    3846: { id: 3846, description: "Discharge battery cell overtemperature alarm", source: "System", classification: "", level: 3 },
    3847: { id: 3847, description: "Discharge battery cell undertemperature alarm", source: "System", classification: "", level: 3 },
    3848: { id: 3848, description: "Battery cell temperature difference alarm", source: "System", classification: "", level: 3 },
    3849: { id: 3849, description: "SOC differential over threshold alarm", source: "System", classification: "", level: 3 },
    3850: { id: 3850, description: "Temperature rise over threshold alarm", source: "System", classification: "", level: 3 },
    3851: { id: 3851, description: "PACK overvoltage alarm", source: "System", classification: "", level: 3 },
    3852: { id: 3852, description: "PACK undervoltage alarm", source: "System", classification: "", level: 3 },
    3853: { id: 3853, description: "CMU–BCU communication fault – applies only to this battery cluster", source: "System", classification: "", level: 2 },
    3854: { id: 3854, description: "SOH low alarm", source: "System", classification: "", level: 1 },
  },
  "6C1": {
    4768: { id: 4768, description: "DI4 status (Emergency-stop signal)", source: "System", classification: "" },
    4769: { id: 4769, description: "DI5 status (Upper level monitoring fault signal)", source: "System", classification: "" },
  },
  "6E1": {
    4781: { id: 4781, description: "Power supply voltage undervoltage alarm", source: "System", classification: "", level: 1 },
    4782: { id: 4782, description: "Power supply voltage overvoltage alarm", source: "System", classification: "", level: 1 },
    4783: { id: 4783, description: "PACK temperature overtemperature alarm", source: "System", classification: "", level: 1 },
    4784: { id: 4784, description: "Cluster end voltage undervoltage alarm", source: "System", classification: "", level: 1 },
    4785: { id: 4785, description: "Cluster terminal voltage overvoltage alarm", source: "System", classification: "", level: 1 },
    4786: { id: 4786, description: "Charging overcurrent alarm", source: "System", classification: "", level: 1 },
    4787: { id: 4787, description: "Power terminal overtemperature alarm", source: "System", classification: "", level: 1 },
    4788: { id: 4788, description: "Feed current overcurrent alarm", source: "System", classification: "", level: 1 },
    4789: { id: 4789, description: "Discharge overcurrent alarm", source: "System", classification: "", level: 1 },
    4790: { id: 4790, description: "Low insulation alarm", source: "System", classification: "", level: 1 },
    4791: { id: 4791, description: "SOC low alarm", source: "System", classification: "", level: 1 },
    4792: { id: 4792, description: "SOC ultra high alarm", source: "System", classification: "", level: 1 },
    4793: { id: 4793, description: "Battery cell voltage overvoltage alarm", source: "System", classification: "", level: 1 },
    4794: { id: 4794, description: "Battery cell voltage undervoltage alarm", source: "System", classification: "", level: 1 },
    4795: { id: 4795, description: "Battery cell voltage difference alarm", source: "System", classification: "", level: 1 },
    4796: { id: 4796, description: "Charging battery cell overtemperature alarm", source: "System", classification: "", level: 1 },
  },
  "6E2": {
    4797: { id: 4797, description: "Charging battery cell undertemperature alarm", source: "System", classification: "", level: 1 },
    4798: { id: 4798, description: "Discharge battery cell overtemperature alarm", source: "System", classification: "", level: 1 },
    4799: { id: 4799, description: "Discharge battery cell undertemperature alarm", source: "System", classification: "", level: 1 },
    4800: { id: 4800, description: "Battery cell temperature difference alarm", source: "System", classification: "", level: 1 },
    4801: { id: 4801, description: "SOC differential over threshold alarm", source: "System", classification: "", level: 1 },
    4802: { id: 4802, description: "Temperature rise over threshold alarm", source: "System", classification: "", level: 1 },
    4803: { id: 4803, description: "PACK overvoltage alarm", source: "System", classification: "", level: 1 },
    4804: { id: 4804, description: "PACK undervoltage alarm", source: "System", classification: "", level: 1 },
    4805: { id: 4805, description: "Power supply voltage undervoltage alarm", source: "System", classification: "", level: 2 },
    4806: { id: 4806, description: "Power supply voltage overvoltage alarm", source: "System", classification: "", level: 2 },
    4807: { id: 4807, description: "PACK temperature overtemperature alarm", source: "System", classification: "", level: 2 },
    4808: { id: 4808, description: "Cluster end voltage undervoltage alarm", source: "System", classification: "", level: 2 },
    4809: { id: 4809, description: "Cluster terminal voltage overvoltage alarm", source: "System", classification: "", level: 2 },
    4810: { id: 4810, description: "Charging overcurrent alarm", source: "System", classification: "", level: 2 },
    4811: { id: 4811, description: "Power terminal overtemperature alarm", source: "System", classification: "", level: 2 },
    4812: { id: 4812, description: "Feed current overcurrent alarm", source: "System", classification: "", level: 2 },
  },
  "6E3": {
    4813: { id: 4813, description: "Discharge overcurrent alarm", source: "System", classification: "", level: 2 },
    4814: { id: 4814, description: "Low insulation alarm", source: "System", classification: "", level: 2 },
    4817: { id: 4817, description: "Battery cell voltage overvoltage alarm", source: "System", classification: "", level: 2 },
    4818: { id: 4818, description: "Battery cell voltage undervoltage alarm", source: "System", classification: "", level: 2 },
    4819: { id: 4819, description: "Battery cell voltage difference alarm", source: "System", classification: "", level: 2 },
    4820: { id: 4820, description: "Charging battery cell overtemperature alarm", source: "System", classification: "", level: 2 },
    4821: { id: 4821, description: "Charging battery cell undertemperature alarm", source: "System", classification: "", level: 2 },
    4822: { id: 4822, description: "Discharge battery cell overtemperature alarm", source: "System", classification: "", level: 2 },
    4823: { id: 4823, description: "Discharge battery cell undertemperature alarm", source: "System", classification: "", level: 2 },
    4824: { id: 4824, description: "Battery cell temperature difference alarm", source: "System", classification: "", level: 2 },
    4825: { id: 4825, description: "SOC differential over threshold alarm", source: "System", classification: "", level: 2 },
    4826: { id: 4826, description: "Temperature rise over threshold alarm", source: "System", classification: "", level: 2 },
    4827: { id: 4827, description: "PACK overvoltage alarm", source: "System", classification: "", level: 2 },
    4828: { id: 4828, description: "PACK undervoltage alarm", source: "System", classification: "", level: 2 },
  },
  "6E4": {
    4829: { id: 4829, description: "Power supply voltage undervoltage alarm", source: "System", classification: "", level: 3 },
    4830: { id: 4830, description: "Power supply voltage overvoltage alarm", source: "System", classification: "", level: 3 },
    4831: { id: 4831, description: "PACK temperature overtemperature alarm", source: "System", classification: "", level: 3 },
    4832: { id: 4832, description: "Cluster end voltage undervoltage alarm", source: "System", classification: "", level: 3 },
    4833: { id: 4833, description: "Cluster terminal voltage overvoltage alarm", source: "System", classification: "", level: 3 },
    4834: { id: 4834, description: "Charging overcurrent alarm", source: "System", classification: "", level: 3 },
    4835: { id: 4835, description: "Power terminal overtemperature alarm", source: "System", classification: "", level: 3 },
    4836: { id: 4836, description: "Feed current overcurrent alarm", source: "System", classification: "", level: 3 },
    4837: { id: 4837, description: "Discharge overcurrent alarm", source: "System", classification: "", level: 3 },
    4838: { id: 4838, description: "Low insulation alarm", source: "System", classification: "", level: 3 },
    4841: { id: 4841, description: "Battery cell voltage overvoltage alarm", source: "System", classification: "", level: 3 },
    4842: { id: 4842, description: "Battery cell voltage undervoltage alarm", source: "System", classification: "", level: 3 },
    4843: { id: 4843, description: "Battery cell voltage difference alarm", source: "System", classification: "", level: 3 },
    4844: { id: 4844, description: "Charging battery cell overtemperature alarm", source: "System", classification: "", level: 3 },
  },
  "6E5": {
    4845: { id: 4845, description: "Charging battery cell undertemperature alarm", source: "System", classification: "", level: 3 },
    4846: { id: 4846, description: "Discharge battery cell overtemperature alarm", source: "System", classification: "", level: 3 },
    4847: { id: 4847, description: "Discharge battery cell undertemperature alarm", source: "System", classification: "", level: 3 },
    4848: { id: 4848, description: "Battery cell temperature difference alarm", source: "System", classification: "", level: 3 },
    4849: { id: 4849, description: "SOC differential over threshold alarm", source: "System", classification: "", level: 3 },
    4850: { id: 4850, description: "Temperature rise over threshold alarm", source: "System", classification: "", level: 3 },
    4851: { id: 4851, description: "PACK overvoltage alarm", source: "System", classification: "", level: 3 },
    4852: { id: 4852, description: "PACK undervoltage alarm", source: "System", classification: "", level: 3 },
    4853: { id: 4853, description: "CMU–BCU communication fault", source: "System", classification: "", level: 2 },
    4854: { id: 4854, description: "SOH low alarm", source: "System", classification: "", level: 1 },
  },
  "7C1": {
    5768: { id: 5768, description: "DI4 status (Emergency-stop signal)", source: "System", classification: "" },
    5769: { id: 5769, description: "DI5 status (Upper level monitoring fault signal)", source: "System", classification: "" },
  },
  "7E1": {
    5781: { id: 5781, description: "Power supply voltage undervoltage alarm", source: "System", classification: "", level: 1 },
    5782: { id: 5782, description: "Power supply voltage overvoltage alarm", source: "System", classification: "", level: 1 },
    5783: { id: 5783, description: "PACK temperature overtemperature alarm", source: "System", classification: "", level: 1 },
    5784: { id: 5784, description: "Cluster end voltage undervoltage alarm", source: "System", classification: "", level: 1 },
    5785: { id: 5785, description: "Cluster terminal voltage overvoltage alarm", source: "System", classification: "", level: 1 },
    5786: { id: 5786, description: "Charging overcurrent alarm", source: "System", classification: "", level: 1 },
    5787: { id: 5787, description: "Power terminal overtemperature alarm", source: "System", classification: "", level: 1 },
    5788: { id: 5788, description: "Feed current overcurrent alarm", source: "System", classification: "", level: 1 },
    5789: { id: 5789, description: "Discharge overcurrent alarm", source: "System", classification: "", level: 1 },
    5790: { id: 5790, description: "Low insulation alarm", source: "System", classification: "", level: 1 },
    5791: { id: 5791, description: "SOC low alarm", source: "System", classification: "", level: 1 },
    5792: { id: 5792, description: "SOC ultra high alarm", source: "System", classification: "", level: 1 },
    5793: { id: 5793, description: "Battery cell voltage overvoltage alarm", source: "System", classification: "", level: 1 },
    5794: { id: 5794, description: "Battery cell voltage undervoltage alarm", source: "System", classification: "", level: 1 },
    5795: { id: 5795, description: "Battery cell voltage difference alarm", source: "System", classification: "", level: 1 },
    5796: { id: 5796, description: "Charging battery cell overtemperature alarm", source: "System", classification: "", level: 1 },
  },
  "7E2": {
    5797: { id: 5797, description: "Charging battery cell undertemperature alarm", source: "System", classification: "", level: 1 },
    5798: { id: 5798, description: "Discharge battery cell overtemperature alarm", source: "System", classification: "", level: 1 },
    5799: { id: 5799, description: "Discharge battery cell undertemperature alarm", source: "System", classification: "", level: 1 },
    5800: { id: 5800, description: "Battery cell temperature difference alarm", source: "System", classification: "", level: 1 },
    5801: { id: 5801, description: "SOC differential over threshold alarm", source: "System", classification: "", level: 1 },
    5802: { id: 5802, description: "Temperature rise over threshold alarm", source: "System", classification: "", level: 1 },
    5803: { id: 5803, description: "PACK overvoltage alarm", source: "System", classification: "", level: 1 },
    5804: { id: 5804, description: "PACK undervoltage alarm", source: "System", classification: "", level: 1 },
    5805: { id: 5805, description: "Power supply voltage undervoltage alarm", source: "System", classification: "", level: 2 },
    5806: { id: 5806, description: "Power supply voltage overvoltage alarm", source: "System", classification: "", level: 2 },
    5807: { id: 5807, description: "PACK temperature overtemperature alarm", source: "System", classification: "", level: 2 },
    5808: { id: 5808, description: "Cluster end voltage undervoltage alarm", source: "System", classification: "", level: 2 },
    5809: { id: 5809, description: "Cluster terminal voltage overvoltage alarm", source: "System", classification: "", level: 2 },
    5810: { id: 5810, description: "Charging overcurrent alarm", source: "System", classification: "", level: 2 },
    5811: { id: 5811, description: "Power terminal overtemperature alarm", source: "System", classification: "", level: 2 },
    5812: { id: 5812, description: "Feed current overcurrent alarm", source: "System", classification: "", level: 2 },
  },
  "7E3": {
    5813: { id: 5813, description: "Discharge overcurrent alarm", source: "System", classification: "", level: 2 },
    5814: { id: 5814, description: "Low insulation alarm", source: "System", classification: "", level: 2 },
    5817: { id: 5817, description: "Battery cell voltage overvoltage alarm", source: "System", classification: "", level: 2 },
    5818: { id: 5818, description: "Battery cell voltage undervoltage alarm", source: "System", classification: "", level: 2 },
    5819: { id: 5819, description: "Battery cell voltage difference alarm", source: "System", classification: "", level: 2 },
    5820: { id: 5820, description: "Charging battery cell overtemperature alarm", source: "System", classification: "", level: 2 },
    5821: { id: 5821, description: "Charging battery cell undertemperature alarm", source: "System", classification: "", level: 2 },
    5822: { id: 5822, description: "Discharge battery cell overtemperature alarm", source: "System", classification: "", level: 2 },
    5823: { id: 5823, description: "Discharge battery cell undertemperature alarm", source: "System", classification: "", level: 2 },
    5824: { id: 5824, description: "Battery cell temperature difference alarm", source: "System", classification: "", level: 2 },
    5825: { id: 5825, description: "SOC differential over threshold alarm", source: "System", classification: "", level: 2 },
    5826: { id: 5826, description: "Temperature rise over threshold alarm", source: "System", classification: "", level: 2 },
    5827: { id: 5827, description: "PACK overvoltage alarm", source: "System", classification: "", level: 2 },
    5828: { id: 5828, description: "PACK undervoltage alarm", source: "System", classification: "", level: 2 },
  },
  "7E4": {
    5829: { id: 5829, description: "Power supply voltage undervoltage alarm", source: "System", classification: "", level: 3 },
    5830: { id: 5830, description: "Power supply voltage overvoltage alarm", source: "System", classification: "", level: 3 },
    5831: { id: 5831, description: "PACK temperature overtemperature alarm", source: "System", classification: "", level: 3 },
    5832: { id: 5832, description: "Cluster end voltage undervoltage alarm", source: "System", classification: "", level: 3 },
    5833: { id: 5833, description: "Cluster terminal voltage overvoltage alarm", source: "System", classification: "", level: 3 },
    5834: { id: 5834, description: "Charging overcurrent alarm", source: "System", classification: "", level: 3 },
    5835: { id: 5835, description: "Power terminal overtemperature alarm", source: "System", classification: "", level: 3 },
    5836: { id: 5836, description: "Feed current overcurrent alarm", source: "System", classification: "", level: 3 },
    5837: { id: 5837, description: "Discharge overcurrent alarm", source: "System", classification: "", level: 3 },
    5838: { id: 5838, description: "Low insulation alarm", source: "System", classification: "", level: 3 },
    5841: { id: 5841, description: "Battery cell voltage overvoltage alarm", source: "System", classification: "", level: 3 },
    5842: { id: 5842, description: "Battery cell voltage undervoltage alarm", source: "System", classification: "", level: 3 },
    5843: { id: 5843, description: "Battery cell voltage difference alarm", source: "System", classification: "", level: 3 },
    5844: { id: 5844, description: "Charging battery cell overtemperature alarm", source: "System", classification: "", level: 3 },
  },
  "7E5": {
    5845: { id: 5845, description: "Charging battery cell undertemperature alarm", source: "System", classification: "", level: 3 },
    5846: { id: 5846, description: "Discharge battery cell overtemperature alarm", source: "System", classification: "", level: 3 },
    5847: { id: 5847, description: "Discharge battery cell undertemperature alarm", source: "System", classification: "", level: 3 },
    5848: { id: 5848, description: "Battery cell temperature difference alarm", source: "System", classification: "", level: 3 },
    5849: { id: 5849, description: "SOC differential over threshold alarm", source: "System", classification: "", level: 3 },
    5850: { id: 5850, description: "Temperature rise over threshold alarm", source: "System", classification: "", level: 3 },
    5851: { id: 5851, description: "PACK overvoltage alarm", source: "System", classification: "", level: 3 },
    5852: { id: 5852, description: "PACK undervoltage alarm", source: "System", classification: "", level: 3 },
    5853: { id: 5853, description: "CMU-BCU communication fault", source: "System", classification: "", level: 2 },
    5854: { id: 5854, description: "SOH low alarm", source: "System", classification: "", level: 1 },
  },
  "81": {
    65: { id: 65, description: "Monitor board over-temperature alarm", source: "System", classification: "", level: 1 },
    66: { id: 66, description: "AC tank over-temperature alarm", source: "System", classification: "", level: 1 },
    67: { id: 67, description: "Monitor board over-temperature protection", source: "System", classification: "", level: 3 },
    68: { id: 68, description: "AC tank over-temperature protection", source: "System", classification: "", level: 3 },
    69: { id: 69, description: "Monitor board low-temperature alarm", source: "System", classification: "", level: 1 },
    70: { id: 70, description: "AC tank low-temperature alarm", source: "System", classification: "", level: 1 },
    71: { id: 71, description: "Monitor board temperature sensor fault", source: "System", classification: "", level: 1 },
    72: { id: 72, description: "AC tank temperature sensor fault", source: "System", classification: "", level: 1 },
    73: { id: 73, description: "Water immersion alarm", source: "System", classification: "", level: 1 },
    74: { id: 74, description: "Access control alarm", source: "System", classification: "", level: 3 },
    75: { id: 75, description: "AC SPD fault", source: "System", classification: "", level: 1 },
    76: { id: 76, description: "Grid connected switch position fault", source: "System", classification: "", level: 3 },
    77: { id: 77, description: "Fan 1 fault", source: "System", classification: "", level: 1 },
    78: { id: 78, description: "Fan 2 fault", source: "System", classification: "", level: 1 },
    79: { id: 79, description: "Insulation detection equipment fault", source: "System", classification: "", level: 1 },
    80: { id: 80, description: "Insulation detection fault", source: "System", classification: "", level: 3 },
  },
  "82": {
    81: { id: 81, description: "Energy storage cabinet fault (external dry contact)", source: "System", classification: "", level: 1 },
    82: { id: 82, description: "Remote emergency stop fault", source: "System", classification: "", level: 3 },
    83: { id: 83, description: "PCSM1 AC breaker fault", source: "System", classification: "", level: 1 },
    84: { id: 84, description: "PCSM2 AC breaker fault", source: "System", classification: "", level: 1 },
    85: { id: 85, description: "PCSM3 AC breaker fault", source: "System", classification: "", level: 1 },
    86: { id: 86, description: "PCSM4 AC breaker fault", source: "System", classification: "", level: 1 },
    87: { id: 87, description: "PCSM5 AC breaker fault", source: "System", classification: "", level: 1 },
    88: { id: 88, description: "PCSM6 AC breaker fault", source: "System", classification: "", level: 1 },
    89: { id: 89, description: "PCSM1 CAN communications blackout", source: "System", classification: "", level: 1 },
    90: { id: 90, description: "PCSM2 CAN communications blackout", source: "System", classification: "", level: 1 },
    91: { id: 91, description: "PCSM3 CAN communications blackout", source: "System", classification: "", level: 1 },
    92: { id: 92, description: "PCSM4 CAN communications blackout", source: "System", classification: "", level: 1 },
    93: { id: 93, description: "PCSM5 CAN communications blackout", source: "System", classification: "", level: 1 },
    94: { id: 94, description: "PCSM6 CAN communications blackout", source: "System", classification: "", level: 1 },
    95: { id: 95, description: "Metering meter1 communications blackout", source: "System", classification: "", level: 1 },
    96: { id: 96, description: "Anti backflow meter communications blackout", source: "System", classification: "", level: 1 },
  },
  "83": {
    97: { id: 97, description: "Microcomputer device communications blackout", source: "System", classification: "", level: 1 },
    98: { id: 98, description: "Dehumidifier communications blackout", source: "System", classification: "", level: 1 },
    99: { id: 99, description: "Measuring and control device communications blackout", source: "System", classification: "", level: 1 },
    100: { id: 100, description: "PCS module model reading error", source: "System", classification: "", level: 3 },
    101: { id: 101, description: "Anti backflow fault", source: "System", classification: "", level: 1 },
    102: { id: 102, description: "STS switch position fault", source: "System", classification: "", level: 3 },
    103: { id: 103, description: "Bypass switch fault", source: "System", classification: "", level: 3 },
    104: { id: 104, description: "SPD1 alarm", source: "System", classification: "", level: 1 },
    105: { id: 105, description: "SPD2 alarm", source: "System", classification: "", level: 1 },
    106: { id: 106, description: "QF1 switch fault", source: "System", classification: "", level: 3 },
    107: { id: 107, description: "Metering meter2 communications blackout", source: "System", classification: "", level: 1 },
    108: { id: 108, description: "First metering meter 3 communications blackout", source: "System", classification: "", level: 1 },
    109: { id: 109, description: "Second metering meter 3 communications blackout", source: "System", classification: "", level: 1 },
    110: { id: 110, description: "Third metering meter 3 communications blackout", source: "System", classification: "", level: 1 },
    111: { id: 111, description: "Fourth metering meter 3 communications blackout", source: "System", classification: "", level: 1 },
    112: { id: 112, description: "Fifth metering meter 3 communications blackout", source: "System", classification: "", level: 1 },
  },
  "84": {
    113: { id: 113, description: "First photovoltaic meter communications blackout", source: "System", classification: "", level: 1 },
    114: { id: 114, description: "Second photovoltaic meter communications blackout", source: "System", classification: "", level: 1 },
    115: { id: 115, description: "Third photovoltaic meter communications blackout", source: "System", classification: "", level: 1 },
  },
  "8C1": {
    400: { id: 400, description: "Grid overvoltage", source: "System", classification: "", level: 3 },
    401: { id: 401, description: "Grid undervoltage", source: "System", classification: "", level: 3 },
    402: { id: 402, description: "Grid overfrequency", source: "System", classification: "", level: 3 },
    403: { id: 403, description: "Grid underfrequency", source: "System", classification: "", level: 3 },
    404: { id: 404, description: "Leakage current fault", source: "System", classification: "", level: 3 },
    405: { id: 405, description: "OVRT fault", source: "System", classification: "", level: 3 },
    406: { id: 406, description: "LVRT fault", source: "System", classification: "", level: 3 },
    407: { id: 407, description: "Island error", source: "System", classification: "", level: 3 },
    408: { id: 408, description: "Grid OVP Instant 1", source: "System", classification: "", level: 3 },
    409: { id: 409, description: "Grid OVP Instant 2", source: "System", classification: "", level: 3 },
    410: { id: 410, description: "Grid line voltage error", source: "System", classification: "", level: 3 },
    413: { id: 413, description: "VGridUnbalance", source: "System", classification: "", level: 3 },
  },
  "8C2": {
    416: { id: 416, description: "Grid current sampling error", source: "System", classification: "", level: 3 },
    417: { id: 417, description: "Grid current DCI sampling error", source: "System", classification: "", level: 3 },
    419: { id: 419, description: "Grid voltage sampling error", source: "System", classification: "", level: 3 },
    421: { id: 421, description: "Leakage current sampling error (AC side)", source: "System", classification: "", level: 3 },
    429: { id: 429, description: "Grid voltage consistency error", source: "System", classification: "", level: 3 },
  },
  "8C3": {
    436: { id: 436, description: "Auxiliary power supply error", source: "System", classification: "", level: 3 },
    437: { id: 437, description: "Inverter soft start failure", source: "System", classification: "", level: 3 },
    440: { id: 440, description: "AC relay detection failed", source: "System", classification: "", level: 3 },
    441: { id: 441, description: "Low insulation impedance", source: "System", classification: "", level: 3 },
    442: { id: 442, description: "swtohwMatchErr", source: "System", classification: "", level: 3 },
    445: { id: 445, description: "Input reverse connection error", source: "System", classification: "", level: 3 },
  },
  "8C4": {
    455: { id: 455, description: "Module temperature difference suprathreshold", source: "System", classification: "", level: 3 },
    456: { id: 456, description: "Environmental temperature 1 protection", source: "System", classification: "", level: 3 },
    458: { id: 458, description: "Module 1 Temperature Protection", source: "System", classification: "", level: 3 },
    459: { id: 459, description: "Module 2 Temperature Protection", source: "System", classification: "", level: 3 },
    460: { id: 460, description: "Module 3 Temperature Protection", source: "System", classification: "", level: 3 },
    461: { id: 461, description: "Module 4 Temperature Protection", source: "System", classification: "", level: 3 },
    462: { id: 462, description: "Module 5 Temperature Protection", source: "System", classification: "", level: 3 },
    463: { id: 463, description: "Module 6 Temperature Protection", source: "System", classification: "", level: 3 },
  },
  "8C5": {
    464: { id: 464, description: "Unbalanced effective value of bus voltage", source: "System", classification: "", level: 3 },
    466: { id: 466, description: "Under voltage of the busbar during grid connection", source: "System", classification: "", level: 3 },
    469: { id: 469, description: "Battery overvoltage", source: "System", classification: "", level: 3 },
    471: { id: 471, description: "Inverter bus software overvoltage", source: "System", classification: "", level: 3 },
    472: { id: 472, description: "Inverter bus software undervoltage", source: "System", classification: "", level: 3 },
  },
  "8C6": {
    481: { id: 481, description: "DCI Overcurrent protection", source: "System", classification: "", level: 3 },
    482: { id: 482, description: "Output instantaneous current protection", source: "System", classification: "", level: 3 },
    484: { id: 484, description: "Output effective value current protection", source: "System", classification: "", level: 3 },
    487: { id: 487, description: "Output current imbalance", source: "System", classification: "", level: 3 },
    489: { id: 489, description: "IbalanceOCP", source: "System", classification: "", level: 3 },
    490: { id: 490, description: "Resover", source: "System", classification: "", level: 3 },
    491: { id: 491, description: "Software wave by wave current limiting protection", source: "System", classification: "", level: 3 },
  },
  "8C7": {
    497: { id: 497, description: "Inverter bus hardware overvoltage", source: "System", classification: "", level: 3 },
    499: { id: 499, description: "Battery hardware overcurrent", source: "System", classification: "", level: 3 },
    502: { id: 502, description: "AC output hardware overcurrent", source: "System", classification: "", level: 3 },
    506: { id: 506, description: "Hardware version mismatch", source: "System", classification: "", level: 3 },
    509: { id: 509, description: "Overload1", source: "System", classification: "", level: 3 },
  },
  "8C8": {
  },
  "8C9": {
  },
  "8CA": {
    544: { id: 544, description: "Grid phase sequence error", source: "System", classification: "", level: 3 },
    545: { id: 545, description: "Phase to ground fault", source: "System", classification: "", level: 3 },
    546: { id: 546, description: "TempErrPowerPort", source: "System", classification: "", level: 3 },
    547: { id: 547, description: "Short-circuit protection equipment fault", source: "System", classification: "", level: 3 },
    548: { id: 548, description: "DC relay error", source: "System", classification: "", level: 3 },
    549: { id: 549, description: "TempErrBalanceIGBT", source: "System", classification: "", level: 3 },
    550: { id: 550, description: "Temperature module temperature low protection", source: "System", classification: "", level: 3 },
    551: { id: 551, description: "Communication reverse start timeout", source: "System", classification: "", level: 3 },
    552: { id: 552, description: "Overmodulation", source: "System", classification: "", level: 3 },
    553: { id: 553, description: "Device ID mismatch", source: "System", classification: "", level: 3 },
    554: { id: 554, description: "Main DSP communication fault Inner CAN", source: "System", classification: "", level: 3 },
    555: { id: 555, description: "Carrier synchronization signal fault", source: "System", classification: "", level: 3 },
    557: { id: 557, description: "DspSoftwareErr", source: "System", classification: "", level: 3 },
    558: { id: 558, description: "BMSFault", source: "System", classification: "", level: 3 },
  },
  "8CB": {
    564: { id: 564, description: "EPO", source: "System", classification: "", level: 3 },
    568: { id: 568, description: "InFanFault1", source: "System", classification: "", level: 3 },
    569: { id: 569, description: "InFanFault2", source: "System", classification: "", level: 3 },
    570: { id: 570, description: "OutFanFault1", source: "System", classification: "", level: 3 },
    571: { id: 571, description: "OutFanFault2", source: "System", classification: "", level: 3 },
    572: { id: 572, description: "OutFanFault3", source: "System", classification: "", level: 3 },
    573: { id: 573, description: "OutFanFault4", source: "System", classification: "", level: 3 },
  },
  "8CC": {
    576: { id: 576, description: "ISO Alarm prompt", source: "System", classification: "", level: 1 },
    577: { id: 577, description: "Auxiliary source alarm", source: "System", classification: "", level: 1 },
    578: { id: 578, description: "DC SPD alarm", source: "System", classification: "", level: 1 },
    579: { id: 579, description: "AC SPD alarm", source: "System", classification: "", level: 1 },
    580: { id: 580, description: "DC voltage input undervoltage", source: "System", classification: "", level: 1 },
    581: { id: 581, description: "DC voltage input overvoltage", source: "System", classification: "", level: 1 },
    582: { id: 582, description: "ResOverWarn", source: "System", classification: "", level: 1 },
    584: { id: 584, description: "IGBT temperature alarm", source: "System", classification: "", level: 1 },
    585: { id: 585, description: "DC relay feedback", source: "System", classification: "", level: 1 },
    586: { id: 586, description: "Internal fan fault", source: "System", classification: "", level: 1 },
    587: { id: 587, description: "External fault", source: "System", classification: "", level: 1 },
    588: { id: 588, description: "BMSWarn", source: "System", classification: "", level: 1 },
    589: { id: 589, description: "TempWarnPowerPort", source: "System", classification: "", level: 1 },
    590: { id: 590, description: "CarrierSynWarn", source: "System", classification: "", level: 1 },
  },
  "8CD": {
    593: { id: 593, description: "Over temperature load reduction", source: "System", classification: "", level: 1 },
    594: { id: 594, description: "BUS overvoltage load reduction", source: "System", classification: "", level: 1 },
    597: { id: 597, description: "DRMsDerating", source: "System", classification: "", level: 1 },
    600: { id: 600, description: "OVUVDerating", source: "System", classification: "", level: 1 },
    604: { id: 604, description: "BUS undervoltage load reduction", source: "System", classification: "", level: 1 },
    605: { id: 605, description: "Under frequency load reduction", source: "System", classification: "", level: 1 },
    606: { id: 606, description: "BUS pressure drop load reduction", source: "System", classification: "", level: 1 },
    607: { id: 607, description: "Fan Derating Prompt", source: "System", classification: "", level: 1 },
  },
  "8CE": {
    608: { id: 608, description: "Hardware sampling bias error", source: "System", classification: "", level: 3 },
  },
  "8CF": {
    624: { id: 624, description: "Main DSP communication fault External CAN", source: "System", classification: "", level: 3 },
    625: { id: 625, description: "Slave DSP communication fault SCI", source: "System", classification: "", level: 3 },
  },
};

/**
 * Implements fault code mapping between PCU and G3 system.
 *
 * Mapping specifications:
 * - Each fault contains 16 distinct alarms
 * - PCU alarms (pcuWarningsFaults) start from ID 800
 * - Mapping is performed starting from fault 51 (800 / 16 are used) in G3 system
 */
Object.entries(pcuWarningsFaults).forEach(([stringKey, fault]) => {
  const key = Number(stringKey);
  const calculateKey = 51 + (key - 0x6024);

  faultsG3[calculateKey] = fault;
});
